//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Injectable, InjectionToken, inject } from '@angular/core';
import { ToastService, ToastType } from '@instaclause-webapp/shared-ui';
import { Observable, of, throwError } from 'rxjs';
import { catchError, mergeMap as _observableMergeMap } from 'rxjs/operators';

// rxjs' `of` is overloaded on a rest parameter, so `of<Foo[]>(x)` resolves T to Foo and yields
// an Observable<Foo>. NSwag emits exactly that shape for every array-returning operation, which
// does not compile. This wrapper takes a single value, so the explicit type argument means what
// it reads as.
const _observableOf = <T>(value: T): Observable<T> => of(value);

interface RequestOptions {
  handleError: Boolean;
}

export const apiBaseUrl = new InjectionToken<string>('apiBaseUrl');

@Injectable()
export class ContactsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
   * Retrieves the contacts of the logged user's office.
   * @param contactTypeId (optional) An optional filter for the type of contact to retrieve.
   * @param query (optional)
   * @param sortBy (optional)
   * @param sortAscending (optional)
   * @param skip (optional)
   * @param take (optional)
   * @return OK
   */
  get(
    contactTypeId?: PartyTypeOptions | undefined,

    query?: string | undefined,

    sortBy?: string | undefined,

    sortAscending?: boolean | undefined,

    skip?: number | undefined,

    take?: number | undefined,
    options?: RequestOptions
  ): Observable<GetContactsResponse> {
    let url_ = this.baseUrl + '/contacts?';
    if (contactTypeId === null) throw new Error("The parameter 'contactTypeId' cannot be null.");
    else if (contactTypeId !== undefined)
      url_ += 'contactTypeId=' + encodeURIComponent('' + contactTypeId) + '&';
    if (query === null) throw new Error("The parameter 'query' cannot be null.");
    else if (query !== undefined) url_ += 'query=' + encodeURIComponent('' + query) + '&';
    if (sortBy === null) throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined) url_ += 'sortBy=' + encodeURIComponent('' + sortBy) + '&';
    if (sortAscending === null) throw new Error("The parameter 'sortAscending' cannot be null.");
    else if (sortAscending !== undefined)
      url_ += 'sortAscending=' + encodeURIComponent('' + sortAscending) + '&';
    if (skip === null) throw new Error("The parameter 'skip' cannot be null.");
    else if (skip !== undefined) url_ += 'skip=' + encodeURIComponent('' + skip) + '&';
    if (take === null) throw new Error("The parameter 'take' cannot be null.");
    else if (take !== undefined) url_ += 'take=' + encodeURIComponent('' + take) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetContactsResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetContactsResponse>;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<GetContactsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetContactsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContactsResponse>(null as any);
  }

  /**
   * Creates a new contact for a customer.
   * @param force (optional) A flag indicating whether the creation should be forced.
   * @param body (optional) The request containing the name and type of the new contact, as well as the field values.
   * @return OK
   */
  create(
    force?: boolean | undefined,

    body?: CreateContactRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateContactResponse> {
    let url_ = this.baseUrl + '/contacts?';
    if (force === null) throw new Error("The parameter 'force' cannot be null.");
    else if (force !== undefined) url_ += 'force=' + encodeURIComponent('' + force) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<CreateContactResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<CreateContactResponse>;
          }
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<CreateContactResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateContactResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateContactResponse>(null as any);
  }

  /**
   * Updates an existing contact asynchronously.
   * @param force (optional) A flag indicating whether the update should be forced.
   * @param body (optional) The request containing the contact update information.
   * @return OK
   */
  update(
    force?: boolean | undefined,

    body?: UpdateContactRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateContactResponse> {
    let url_ = this.baseUrl + '/contacts?';
    if (force === null) throw new Error("The parameter 'force' cannot be null.");
    else if (force !== undefined) url_ += 'force=' + encodeURIComponent('' + force) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'put',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<CreateContactResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<CreateContactResponse>;
          }
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<CreateContactResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateContactResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateContactResponse>(null as any);
  }

  /**
   * Retrieves a contact.
   * @param customerContactId The identifier of the customer contact.
   * @param languageId The language interface id.
   * @return OK
   */
  getById(
    customerContactId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetContactResponse> {
    let url_ = this.baseUrl + '/contacts/{customerContactId}?';
    if (customerContactId === undefined || customerContactId === null)
      throw new Error("The parameter 'customerContactId' must be defined.");
    url_ = url_.replace('{customerContactId}', encodeURIComponent('' + customerContactId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetContactResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetContactResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<GetContactResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetContactResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContactResponse>(null as any);
  }

  /**
   * Deletes a contact using the specified customer contact identifier.
   * @param customerContactId The identifier of the customer contact to delete.
   * @param force (optional) A flag indicating whether the deletion should be forced.
   * @return OK
   */
  delete(
    customerContactId: number,

    force?: boolean | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contacts/{customerContactId}?';
    if (customerContactId === undefined || customerContactId === null)
      throw new Error("The parameter 'customerContactId' must be defined.");
    url_ = url_.replace('{customerContactId}', encodeURIComponent('' + customerContactId));
    if (force === null) throw new Error("The parameter 'force' cannot be null.");
    else if (force !== undefined) url_ += 'force=' + encodeURIComponent('' + force) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDelete(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Retrieves the missing fields for a specific customer contact.
   * @param customerContactId The identifier of the customer contact.
   * @param languageId The language interface id.
   * @param snapshotId (optional) The identifier of the snapshot to use for the comparison.
   * @return OK
   */
  getFieldsMissing(
    customerContactId: number,

    languageId: number,

    snapshotId?: number | undefined,
    options?: RequestOptions
  ): Observable<GetContactMissingFieldsResponse> {
    let url_ = this.baseUrl + '/contacts/{customerContactId}/fields/missing?';
    if (customerContactId === undefined || customerContactId === null)
      throw new Error("The parameter 'customerContactId' must be defined.");
    url_ = url_.replace('{customerContactId}', encodeURIComponent('' + customerContactId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    if (snapshotId === null) throw new Error("The parameter 'snapshotId' cannot be null.");
    else if (snapshotId !== undefined)
      url_ += 'snapshotId=' + encodeURIComponent('' + snapshotId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFieldsMissing(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetFieldsMissing(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetContactMissingFieldsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContactMissingFieldsResponse>;
          }
        })
      );
  }

  protected processGetFieldsMissing(
    response: HttpResponseBase
  ): Observable<GetContactMissingFieldsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as GetContactMissingFieldsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContactMissingFieldsResponse>(null as any);
  }

  /**
   * Gets all contracts associated with a specific contact.
   * @param customerContactId The ID of the contact.
   * @param languageId The ID of the interface language.
   * @return OK
   */
  getContracts(
    customerContactId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetContactContractsResponse> {
    let url_ = this.baseUrl + '/contacts/{customerContactId}/contracts?';
    if (customerContactId === undefined || customerContactId === null)
      throw new Error("The parameter 'customerContactId' must be defined.");
    url_ = url_.replace('{customerContactId}', encodeURIComponent('' + customerContactId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetContracts(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetContracts(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetContactContractsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContactContractsResponse>;
          }
        })
      );
  }

  protected processGetContracts(
    response: HttpResponseBase
  ): Observable<GetContactContractsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetContactContractsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContactContractsResponse>(null as any);
  }

  /**
   * Creates or updates a field record for a specific customer contact.
   * @param customerContactId The identifier of the customer contact.
   * @param body (optional) The request containing the field identifier and value to be created.
   * @return OK
   */
  createFields(
    customerContactId: number,

    body?: AnswerContactFieldRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateContactFieldResponse> {
    let url_ = this.baseUrl + '/contacts/{customerContactId}/fields';
    if (customerContactId === undefined || customerContactId === null)
      throw new Error("The parameter 'customerContactId' must be defined.");
    url_ = url_.replace('{customerContactId}', encodeURIComponent('' + customerContactId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateFields(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateFields(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<CreateContactFieldResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CreateContactFieldResponse>;
          }
        })
      );
  }

  protected processCreateFields(
    response: HttpResponseBase
  ): Observable<CreateContactFieldResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateContactFieldResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateContactFieldResponse>(null as any);
  }

  /**
     * Finds the contact of the logged-in customer holding the given registration number
    (KvK or KBO), so a duplicate can be surfaced before a new contact is created.
     * @param registrationNumber The registration number to look up.
     * @return OK
     */
  getLookup(
    registrationNumber: string,
    options?: RequestOptions
  ): Observable<GetContactByRegistrationNumberResponse> {
    let url_ = this.baseUrl + '/contacts/lookup?';
    if (registrationNumber === undefined || registrationNumber === null)
      throw new Error("The parameter 'registrationNumber' must be defined and cannot be null.");
    else url_ += 'registrationNumber=' + encodeURIComponent('' + registrationNumber) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLookup(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetLookup(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetContactByRegistrationNumberResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContactByRegistrationNumberResponse>;
          }
        })
      );
  }

  protected processGetLookup(
    response: HttpResponseBase
  ): Observable<GetContactByRegistrationNumberResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as GetContactByRegistrationNumberResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContactByRegistrationNumberResponse>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class ContractModelsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
   * Retrieves a contract model by its id.
   * @param contractModelId The id of the contract model.
   * @param languageId The id of the language to retrieve the information in.
   * @return OK
   */
  getById(
    contractModelId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetContractModelResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetContractModelResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContractModelResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<GetContractModelResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetContractModelResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractModelResponse>(null as any);
  }

  /**
   * Retrieves a contract model by its id.
   * @param referenceContractModelId The id of the reference contract model.
   * @param snapshotContractModelId The id of the snapshot contract model.
   * @param languageId The id of the language to retrieve the information in.
   * @return OK
   */
  get(
    referenceContractModelId: number,

    snapshotContractModelId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetContractModelResponse> {
    let url_ =
      this.baseUrl + '/contract-models/{referenceContractModelId}/{snapshotContractModelId}?';
    if (referenceContractModelId === undefined || referenceContractModelId === null)
      throw new Error("The parameter 'referenceContractModelId' must be defined.");
    url_ = url_.replace(
      '{referenceContractModelId}',
      encodeURIComponent('' + referenceContractModelId)
    );
    if (snapshotContractModelId === undefined || snapshotContractModelId === null)
      throw new Error("The parameter 'snapshotContractModelId' must be defined.");
    url_ = url_.replace(
      '{snapshotContractModelId}',
      encodeURIComponent('' + snapshotContractModelId)
    );
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetContractModelResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContractModelResponse>;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<GetContractModelResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetContractModelResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractModelResponse>(null as any);
  }

  /**
   * Retrieves a list of contract model groups.
   * @param languageId The id of the language to retrieve the information in.
   * @return OK
   */
  getGroups(
    languageId: number,
    options?: RequestOptions
  ): Observable<GetContractModelGroupsResponse> {
    let url_ = this.baseUrl + '/contract-models/groups?';
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetGroups(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetGroups(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetContractModelGroupsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContractModelGroupsResponse>;
          }
        })
      );
  }

  protected processGetGroups(
    response: HttpResponseBase
  ): Observable<GetContractModelGroupsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as GetContractModelGroupsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractModelGroupsResponse>(null as any);
  }

  /**
     * Imports (or re-imports) the legacy (1.9) category catalog into the database as global
    contract model groups and contract models.
     * @return OK
     */
  createImportCategories(options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/import-categories';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateImportCategories(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateImportCategories(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateImportCategories(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class ContractsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
   * Creates a new contract instance based on a specific contract model and associates it with a customer.
   * @param body (optional) The request object containing the necessary information to create the contract, such as its name, the identifier of the contract model, and the identifier of the customer.
   * @return OK
   */
  create(
    body?: CreateContractRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateContractResponse> {
    let url_ = this.baseUrl + '/contracts';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<CreateContractResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CreateContractResponse>;
          }
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<CreateContractResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateContractResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateContractResponse>(null as any);
  }

  /**
   * Retrieves a list of contracts associated with a specific customer.
   * @param languageId The language interface id.
   * @param query (optional)
   * @param sortBy (optional)
   * @param sortAscending (optional)
   * @param skip (optional)
   * @param take (optional)
   * @param deleted (optional) A flag indicating whether to query soft-deleted contracts.
   * @return OK
   */
  get(
    languageId: number,

    query?: string | undefined,

    sortBy?: string | undefined,

    sortAscending?: boolean | undefined,

    skip?: number | undefined,

    take?: number | undefined,

    deleted?: boolean | undefined,
    options?: RequestOptions
  ): Observable<GetContractsResponse> {
    let url_ = this.baseUrl + '/contracts?';
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    if (query === null) throw new Error("The parameter 'query' cannot be null.");
    else if (query !== undefined) url_ += 'query=' + encodeURIComponent('' + query) + '&';
    if (sortBy === null) throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined) url_ += 'sortBy=' + encodeURIComponent('' + sortBy) + '&';
    if (sortAscending === null) throw new Error("The parameter 'sortAscending' cannot be null.");
    else if (sortAscending !== undefined)
      url_ += 'sortAscending=' + encodeURIComponent('' + sortAscending) + '&';
    if (skip === null) throw new Error("The parameter 'skip' cannot be null.");
    else if (skip !== undefined) url_ += 'skip=' + encodeURIComponent('' + skip) + '&';
    if (take === null) throw new Error("The parameter 'take' cannot be null.");
    else if (take !== undefined) url_ += 'take=' + encodeURIComponent('' + take) + '&';
    if (deleted === null) throw new Error("The parameter 'deleted' cannot be null.");
    else if (deleted !== undefined) url_ += 'deleted=' + encodeURIComponent('' + deleted) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetContractsResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetContractsResponse>;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<GetContractsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetContractsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractsResponse>(null as any);
  }

  /**
   * Retrieves a contract by its id.
   * @param contractId The id of the contract to retrieve.
   * @param languageId The language interface id.
   * @return OK
   */
  getById(
    contractId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetContractResponse> {
    let url_ = this.baseUrl + '/contracts/{contractId}?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetContractResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetContractResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<GetContractResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetContractResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractResponse>(null as any);
  }

  /**
   * Updates a contract with new information.
   * @param contractId The identifier of the contract to update.
   * @param body (optional) The request object containing the new information to update the contract with.
   * @return OK
   */
  update(
    contractId: number,

    body?: UpdateContractRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contracts/{contractId}';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Deletes a contract, removing it from the system.
   * @param contractId The identifier of the contract to delete.
   * @param permanently (optional) A flag indicating whether to force the deletion of the contract, even if it has associated data.
   * @return OK
   */
  delete(
    contractId: number,

    permanently?: boolean | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contracts/{contractId}?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (permanently === null) throw new Error("The parameter 'permanently' cannot be null.");
    else if (permanently !== undefined)
      url_ += 'permanently=' + encodeURIComponent('' + permanently) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDelete(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Restores a soft-deleted contract, making it available again in the system.
   * @param contractId The id of the contract to restore.
   * @return OK
   */
  createRestore(contractId: number, options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/contracts/{contractId}/restore';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateRestore(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateRestore(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateRestore(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
     * Unlocks a locked contract so its fields and parties can be edited again. Its generated documents
    are dropped and it goes back to InProgress; generating the documents locks it again.
     * @param contractId The id of the contract to unlock.
     * @param languageId The language interface id.
     * @return OK
     */
  createUnlock(
    contractId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<UnlockContractResponse> {
    let url_ = this.baseUrl + '/contracts/{contractId}/unlock?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUnlock(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateUnlock(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<UnlockContractResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<UnlockContractResponse>;
          }
        })
      );
  }

  protected processCreateUnlock(response: HttpResponseBase): Observable<UnlockContractResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as UnlockContractResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UnlockContractResponse>(null as any);
  }

  /**
   * Updates the snapshot of a contract model.
   * @param contractId The id of the contract to update the snapshot for.
   * @param body (optional) The request object containing the new snapshot id to update the contract with.
   * @return OK
   */
  createUpdateSnapshot(
    contractId: number,

    body?: UpdateSnapshotRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contracts/{contractId}/update-snapshot';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUpdateSnapshot(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateUpdateSnapshot(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateUpdateSnapshot(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Retrieves a contract metadata object with the contract model and customer contact (assignees) names.
   * @param languageId The language interface id.
   * @return OK
   */
  getMetadata(
    languageId: number,
    options?: RequestOptions
  ): Observable<GetContractMetadataResponse> {
    let url_ = this.baseUrl + '/contracts/metadata?';
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetMetadata(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetMetadata(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetContractMetadataResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContractMetadataResponse>;
          }
        })
      );
  }

  protected processGetMetadata(
    response: HttpResponseBase
  ): Observable<GetContractMetadataResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetContractMetadataResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractMetadataResponse>(null as any);
  }

  /**
     * Queues a document for generation. This endpoint can be called when contract generation fails,
    allowing users to retry the document generation process independently.
     * @param contractId The identifier of the contract for which to queue the document.
     * @param documentId The identifier of the document to queue for generation.
     * @return OK
     */
  createDocumentsQueue(
    contractId: number,

    documentId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contracts/{contractId}/documents/{documentId}/queue';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateDocumentsQueue(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateDocumentsQueue(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateDocumentsQueue(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Resolves the signed URL of a legacy contract's Word document on the legacy (1.9) platform.
   * @param contractId The identifier of the legacy contract.
   * @param documentIndex The zero-based index of the document on the legacy platform, which is what the wizard state reports as the document id of a legacy contract.
   * @return OK
   */
  getLegacyDocumentsDownloadUrl(
    contractId: number,

    documentIndex: number,
    options?: RequestOptions
  ): Observable<LegacyDocumentDownloadUrlResponse> {
    let url_ =
      this.baseUrl + '/contracts/{contractId}/legacy-documents/{documentIndex}/download-url';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (documentIndex === undefined || documentIndex === null)
      throw new Error("The parameter 'documentIndex' must be defined.");
    url_ = url_.replace('{documentIndex}', encodeURIComponent('' + documentIndex));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetLegacyDocumentsDownloadUrl(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetLegacyDocumentsDownloadUrl(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<LegacyDocumentDownloadUrlResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<LegacyDocumentDownloadUrlResponse>;
          }
        })
      );
  }

  protected processGetLegacyDocumentsDownloadUrl(
    response: HttpResponseBase
  ): Observable<LegacyDocumentDownloadUrlResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as LegacyDocumentDownloadUrlResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<LegacyDocumentDownloadUrlResponse>(null as any);
  }

  /**
   * Duplicates an existing contract, creating a new contract with the same field values and optionally role assignees.
   * @param contractId The identifier of the contract to duplicate.
   * @param body (optional) The request containing duplication options.
   * @return OK
   */
  createDuplicate(
    contractId: number,

    body?: DuplicateContractRequest | undefined,
    options?: RequestOptions
  ): Observable<DuplicateContractResponse> {
    let url_ = this.baseUrl + '/contracts/{contractId}/duplicate';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateDuplicate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateDuplicate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<DuplicateContractResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<DuplicateContractResponse>;
          }
        })
      );
  }

  protected processCreateDuplicate(
    response: HttpResponseBase
  ): Observable<DuplicateContractResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DuplicateContractResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<DuplicateContractResponse>(null as any);
  }

  /**
   * Assigns a customer contact to a specific role within a contract.
   * @param contractId The id of the contract to which the contact is being assigned.
   * @param languageId The language interface id.
   * @param body (optional) The request containing details about the assignment: the model role id and either the id of an existing customer contact or the details of a contact to create.
   * @return OK
   */
  createAssignments(
    contractId: number,

    languageId: number,

    body?: AssignContactRequest | undefined,
    options?: RequestOptions
  ): Observable<AssignContactResponse> {
    let url_ = this.baseUrl + '/contracts/{contractId}/assignments?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateAssignments(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateAssignments(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<AssignContactResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<AssignContactResponse>;
          }
        })
      );
  }

  protected processCreateAssignments(
    response: HttpResponseBase
  ): Observable<AssignContactResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AssignContactResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AssignContactResponse>(null as any);
  }

  /**
   * Records the role field values required of an assignment, against the assigned contact.
   * @param contractId The id of the contract containing the assignment.
   * @param assigneeId The id of the assignment whose fields are being answered.
   * @param languageId The language interface id.
   * @param body (optional) The request containing the field values to record.
   * @return OK
   */
  updateAssignmentsFields(
    contractId: number,

    assigneeId: number,

    languageId: number,

    body?: AnswerAssignmentFieldsRequest | undefined,
    options?: RequestOptions
  ): Observable<AnswerAssignmentFieldsResponse> {
    let url_ = this.baseUrl + '/contracts/{contractId}/assignments/{assigneeId}/fields?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (assigneeId === undefined || assigneeId === null)
      throw new Error("The parameter 'assigneeId' must be defined.");
    url_ = url_.replace('{assigneeId}', encodeURIComponent('' + assigneeId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'put',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateAssignmentsFields(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateAssignmentsFields(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<AnswerAssignmentFieldsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<AnswerAssignmentFieldsResponse>;
          }
        })
      );
  }

  protected processUpdateAssignmentsFields(
    response: HttpResponseBase
  ): Observable<AnswerAssignmentFieldsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as AnswerAssignmentFieldsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AnswerAssignmentFieldsResponse>(null as any);
  }

  /**
   * Records the role field values required of an assignment, against one of its representatives.
   * @param contractId The id of the contract containing the assignment.
   * @param assigneeId The id of the assignment the representative belongs to.
   * @param customerContactId The id of the representative customer contact whose fields are being answered.
   * @param languageId The language interface id.
   * @param body (optional) The request containing the field values to record.
   * @return OK
   */
  updateAssignmentsRepresentativesFields(
    contractId: number,

    assigneeId: number,

    customerContactId: number,

    languageId: number,

    body?: AnswerAssignmentFieldsRequest | undefined,
    options?: RequestOptions
  ): Observable<AnswerAssignmentFieldsResponse> {
    let url_ =
      this.baseUrl +
      '/contracts/{contractId}/assignments/{assigneeId}/representatives/{customerContactId}/fields?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (assigneeId === undefined || assigneeId === null)
      throw new Error("The parameter 'assigneeId' must be defined.");
    url_ = url_.replace('{assigneeId}', encodeURIComponent('' + assigneeId));
    if (customerContactId === undefined || customerContactId === null)
      throw new Error("The parameter 'customerContactId' must be defined.");
    url_ = url_.replace('{customerContactId}', encodeURIComponent('' + customerContactId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'put',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateAssignmentsRepresentativesFields(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateAssignmentsRepresentativesFields(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<AnswerAssignmentFieldsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<AnswerAssignmentFieldsResponse>;
          }
        })
      );
  }

  protected processUpdateAssignmentsRepresentativesFields(
    response: HttpResponseBase
  ): Observable<AnswerAssignmentFieldsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as AnswerAssignmentFieldsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AnswerAssignmentFieldsResponse>(null as any);
  }

  /**
   * Sets the number of assignees for a specific model role within a contract.
   * @param contractId The id of the contract containing the role.
   * @param modelRoleId The id of the model role for which to set the assignee count.
   * @param languageId The language interface id.
   * @param body (optional) The desired number of assignees for the specified model role.
   * @return OK
   */
  updateAssignmentsCount(
    contractId: number,

    modelRoleId: number,

    languageId: number,

    body?: number | undefined,
    options?: RequestOptions
  ): Observable<SetAssigneeCountResponse> {
    let url_ = this.baseUrl + '/contracts/{contractId}/assignments/{modelRoleId}/count?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (modelRoleId === undefined || modelRoleId === null)
      throw new Error("The parameter 'modelRoleId' must be defined.");
    url_ = url_.replace('{modelRoleId}', encodeURIComponent('' + modelRoleId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'put',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateAssignmentsCount(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateAssignmentsCount(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<SetAssigneeCountResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<SetAssigneeCountResponse>;
          }
        })
      );
  }

  protected processUpdateAssignmentsCount(
    response: HttpResponseBase
  ): Observable<SetAssigneeCountResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SetAssigneeCountResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SetAssigneeCountResponse>(null as any);
  }

  /**
   * Deletes a role assignment from a contract.
   * @param contractId The id of the contract containing the assignment to be deleted.
   * @param modelRoleId The id of the model role containing the assignment to be deleted.
   * @param customerContactId The customerContactId of the assignment to be deleted.
   * @param languageId The language interface id.
   * @return OK
   */
  deleteAssignments(
    contractId: number,

    modelRoleId: number,

    customerContactId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<DeleteAssignmentResponse> {
    let url_ =
      this.baseUrl + '/contracts/{contractId}/assignments/{modelRoleId}/{customerContactId}?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (modelRoleId === undefined || modelRoleId === null)
      throw new Error("The parameter 'modelRoleId' must be defined.");
    url_ = url_.replace('{modelRoleId}', encodeURIComponent('' + modelRoleId));
    if (customerContactId === undefined || customerContactId === null)
      throw new Error("The parameter 'customerContactId' must be defined.");
    url_ = url_.replace('{customerContactId}', encodeURIComponent('' + customerContactId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteAssignments(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteAssignments(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<DeleteAssignmentResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<DeleteAssignmentResponse>;
          }
        })
      );
  }

  protected processDeleteAssignments(
    response: HttpResponseBase
  ): Observable<DeleteAssignmentResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteAssignmentResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<DeleteAssignmentResponse>(null as any);
  }

  /**
   * Adds a representative to a specified existing assignee, either an existing contact or one created by the request.
   * @param contractId The id of the contract containing the assignment.
   * @param assigneeId The id of the assignee the representative is being added to.
   * @param languageId The language interface id.
   * @param body (optional) The request containing either the id of an existing customer contact or the details of a contact to create.
   * @return OK
   */
  createAssignmentsRepresentatives(
    contractId: number,

    assigneeId: number,

    languageId: number,

    body?: AddRepresentativeRequest | undefined,
    options?: RequestOptions
  ): Observable<AddRepresentativeResponse> {
    let url_ = this.baseUrl + '/contracts/{contractId}/assignments/{assigneeId}/representatives?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (assigneeId === undefined || assigneeId === null)
      throw new Error("The parameter 'assigneeId' must be defined.");
    url_ = url_.replace('{assigneeId}', encodeURIComponent('' + assigneeId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateAssignmentsRepresentatives(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateAssignmentsRepresentatives(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<AddRepresentativeResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<AddRepresentativeResponse>;
          }
        })
      );
  }

  protected processCreateAssignmentsRepresentatives(
    response: HttpResponseBase
  ): Observable<AddRepresentativeResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddRepresentativeResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AddRepresentativeResponse>(null as any);
  }

  /**
   * Removes a representative from a specified existing assignee.
   * @param contractId The id of the contract to which the contact is being assigned.
   * @param assigneeId The id of contract assignee.
   * @param customerContactId The representative customer contact id.
   * @param languageId The language interface id.
   * @return OK
   */
  deleteAssignmentsRepresentatives(
    contractId: number,

    assigneeId: number,

    customerContactId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<RemoveRepresentativeResponse> {
    let url_ =
      this.baseUrl +
      '/contracts/{contractId}/assignments/{assigneeId}/representatives/{customerContactId}?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (assigneeId === undefined || assigneeId === null)
      throw new Error("The parameter 'assigneeId' must be defined.");
    url_ = url_.replace('{assigneeId}', encodeURIComponent('' + assigneeId));
    if (customerContactId === undefined || customerContactId === null)
      throw new Error("The parameter 'customerContactId' must be defined.");
    url_ = url_.replace('{customerContactId}', encodeURIComponent('' + customerContactId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteAssignmentsRepresentatives(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteAssignmentsRepresentatives(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<RemoveRepresentativeResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<RemoveRepresentativeResponse>;
          }
        })
      );
  }

  protected processDeleteAssignmentsRepresentatives(
    response: HttpResponseBase
  ): Observable<RemoveRepresentativeResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as RemoveRepresentativeResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<RemoveRepresentativeResponse>(null as any);
  }

  /**
   * Retrieves the contacts of the office that owns the contract, so one can be picked for a role.
   * @param contractId The id of the contract.
   * @param contactTypeId (optional) An optional filter for the type of contact to retrieve.
   * @param query (optional)
   * @param sortBy (optional)
   * @param sortAscending (optional)
   * @param skip (optional)
   * @param take (optional)
   * @return OK
   */
  getContacts(
    contractId: number,

    contactTypeId?: PartyTypeOptions | undefined,

    query?: string | undefined,

    sortBy?: string | undefined,

    sortAscending?: boolean | undefined,

    skip?: number | undefined,

    take?: number | undefined,
    options?: RequestOptions
  ): Observable<GetContactsResponse> {
    let url_ = this.baseUrl + '/contracts/{contractId}/contacts?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (contactTypeId === null) throw new Error("The parameter 'contactTypeId' cannot be null.");
    else if (contactTypeId !== undefined)
      url_ += 'contactTypeId=' + encodeURIComponent('' + contactTypeId) + '&';
    if (query === null) throw new Error("The parameter 'query' cannot be null.");
    else if (query !== undefined) url_ += 'query=' + encodeURIComponent('' + query) + '&';
    if (sortBy === null) throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined) url_ += 'sortBy=' + encodeURIComponent('' + sortBy) + '&';
    if (sortAscending === null) throw new Error("The parameter 'sortAscending' cannot be null.");
    else if (sortAscending !== undefined)
      url_ += 'sortAscending=' + encodeURIComponent('' + sortAscending) + '&';
    if (skip === null) throw new Error("The parameter 'skip' cannot be null.");
    else if (skip !== undefined) url_ += 'skip=' + encodeURIComponent('' + skip) + '&';
    if (take === null) throw new Error("The parameter 'take' cannot be null.");
    else if (take !== undefined) url_ += 'take=' + encodeURIComponent('' + take) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetContacts(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetContacts(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetContactsResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetContactsResponse>;
          }
        })
      );
  }

  protected processGetContacts(response: HttpResponseBase): Observable<GetContactsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetContactsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContactsResponse>(null as any);
  }

  /**
     * Finds the contact holding the given registration number (KvK or KBO) in the office that owns the
    contract, so a duplicate can be surfaced before a new contact is created for one of its roles.
     * @param contractId The id of the contract.
     * @param registrationNumber The registration number to look up.
     * @return OK
     */
  getContactsLookup(
    contractId: number,

    registrationNumber: string,
    options?: RequestOptions
  ): Observable<GetContactByRegistrationNumberResponse> {
    let url_ = this.baseUrl + '/contracts/{contractId}/contacts/lookup?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (registrationNumber === undefined || registrationNumber === null)
      throw new Error("The parameter 'registrationNumber' must be defined and cannot be null.");
    else url_ += 'registrationNumber=' + encodeURIComponent('' + registrationNumber) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetContactsLookup(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetContactsLookup(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetContactByRegistrationNumberResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContactByRegistrationNumberResponse>;
          }
        })
      );
  }

  protected processGetContactsLookup(
    response: HttpResponseBase
  ): Observable<GetContactByRegistrationNumberResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as GetContactByRegistrationNumberResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContactByRegistrationNumberResponse>(null as any);
  }

  /**
   * Answers a field within a contract, updating or creating a ContractFieldValue record and optionally returning the next missing answer.
   * @param contractId The identifier of the contract containing the field to be answered.
   * @param languageId The language interface id.
   * @param body (optional) The request containing the field identifier and the provided answer value.
   * @return OK
   */
  createFieldsValues(
    contractId: number,

    languageId: number,

    body?: AnswerFieldRequest | undefined,
    options?: RequestOptions
  ): Observable<AnswerFieldResponse> {
    let url_ = this.baseUrl + '/contracts/{contractId}/fields/values?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateFieldsValues(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateFieldsValues(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<AnswerFieldResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<AnswerFieldResponse>;
          }
        })
      );
  }

  protected processCreateFieldsValues(response: HttpResponseBase): Observable<AnswerFieldResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AnswerFieldResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AnswerFieldResponse>(null as any);
  }

  /**
   * Retrieves a list of field values associated with a specific contract, excluding any soft deleted values.
   * @param contractId The identifier of the contract for which to retrieve field values.
   * @param languageId The language interface id.
   * @return OK
   */
  getFieldsValues(
    contractId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetContractFieldsValuesResponse> {
    let url_ = this.baseUrl + '/contracts/{contractId}/fields/values?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFieldsValues(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetFieldsValues(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetContractFieldsValuesResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContractFieldsValuesResponse>;
          }
        })
      );
  }

  protected processGetFieldsValues(
    response: HttpResponseBase
  ): Observable<GetContractFieldsValuesResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as GetContractFieldsValuesResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractFieldsValuesResponse>(null as any);
  }

  /**
   * Deletes a field answer from a contract, effectively removing the associated ContractFieldValue record.
   * @param contractId The id of the contract containing the field answer to be deleted.
   * @param fieldId The id of the field answer to delete.
   * @param languageId The language interface id.
   * @param legacyFieldId (optional) The legacy field id the answer is addressed by, required on a legacy contract.
   * @return OK
   */
  deleteFieldsValues(
    contractId: number,

    fieldId: number,

    languageId: number,

    legacyFieldId?: string | undefined,
    options?: RequestOptions
  ): Observable<DeleteFieldResponse> {
    let url_ = this.baseUrl + '/contracts/{contractId}/fields/values/{fieldId}?';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    if (fieldId === undefined || fieldId === null)
      throw new Error("The parameter 'fieldId' must be defined.");
    url_ = url_.replace('{fieldId}', encodeURIComponent('' + fieldId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    if (legacyFieldId === null) throw new Error("The parameter 'legacyFieldId' cannot be null.");
    else if (legacyFieldId !== undefined)
      url_ += 'legacyFieldId=' + encodeURIComponent('' + legacyFieldId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteFieldsValues(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteFieldsValues(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<DeleteFieldResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<DeleteFieldResponse>;
          }
        })
      );
  }

  protected processDeleteFieldsValues(response: HttpResponseBase): Observable<DeleteFieldResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as DeleteFieldResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<DeleteFieldResponse>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class CustomersClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
   * Retrieves the accountants.
   * @return OK
   */
  getAccountants(options?: RequestOptions): Observable<GetAccountantsResponse> {
    let url_ = this.baseUrl + '/customers/accountants';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAccountants(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetAccountants(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetAccountantsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetAccountantsResponse>;
          }
        })
      );
  }

  protected processGetAccountants(response: HttpResponseBase): Observable<GetAccountantsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetAccountantsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetAccountantsResponse>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class CustomerUsersClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
     * Retrieves the users of the customer, applying the optional generic search filter, sorting,
    and pagination.
     * @param customerId The id of the customer.
     * @param query (optional) 
     * @param sortBy (optional) 
     * @param sortAscending (optional) 
     * @param skip (optional) 
     * @param take (optional) 
     * @return OK
     */
  getUsers(
    customerId: number,

    query?: string | undefined,

    sortBy?: string | undefined,

    sortAscending?: boolean | undefined,

    skip?: number | undefined,

    take?: number | undefined,
    options?: RequestOptions
  ): Observable<GetCustomerUsersResponse> {
    let url_ = this.baseUrl + '/customers/{customerId}/users?';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    if (query === null) throw new Error("The parameter 'query' cannot be null.");
    else if (query !== undefined) url_ += 'query=' + encodeURIComponent('' + query) + '&';
    if (sortBy === null) throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined) url_ += 'sortBy=' + encodeURIComponent('' + sortBy) + '&';
    if (sortAscending === null) throw new Error("The parameter 'sortAscending' cannot be null.");
    else if (sortAscending !== undefined)
      url_ += 'sortAscending=' + encodeURIComponent('' + sortAscending) + '&';
    if (skip === null) throw new Error("The parameter 'skip' cannot be null.");
    else if (skip !== undefined) url_ += 'skip=' + encodeURIComponent('' + skip) + '&';
    if (take === null) throw new Error("The parameter 'take' cannot be null.");
    else if (take !== undefined) url_ += 'take=' + encodeURIComponent('' + take) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUsers(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetUsers(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetCustomerUsersResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetCustomerUsersResponse>;
          }
        })
      );
  }

  protected processGetUsers(response: HttpResponseBase): Observable<GetCustomerUsersResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerUsersResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetCustomerUsersResponse>(null as any);
  }

  /**
     * Creates a user for the customer. The user can log in with the given email and password
    immediately.
     * @param customerId The id of the customer.
     * @param body (optional) The request containing the user data.
     * @return OK
     */
  createUsers(
    customerId: number,

    body?: CreateCustomerUserRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateCustomerUserResponse> {
    let url_ = this.baseUrl + '/customers/{customerId}/users';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUsers(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateUsers(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<CreateCustomerUserResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CreateCustomerUserResponse>;
          }
        })
      );
  }

  protected processCreateUsers(response: HttpResponseBase): Observable<CreateCustomerUserResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateCustomerUserResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateCustomerUserResponse>(null as any);
  }

  /**
   * Retrieves a single user of the customer.
   * @param customerId The id of the customer.
   * @param userId The id of the user.
   * @return OK
   */
  getUsers_GET2(
    customerId: number,

    userId: number,
    options?: RequestOptions
  ): Observable<GetCustomerUserResponse> {
    let url_ = this.baseUrl + '/customers/{customerId}/users/{userId}';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUsers_GET2(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetUsers_GET2(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetCustomerUserResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetCustomerUserResponse>;
          }
        })
      );
  }

  protected processGetUsers_GET2(response: HttpResponseBase): Observable<GetCustomerUserResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerUserResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetCustomerUserResponse>(null as any);
  }

  /**
   * Updates the display name and role of a user of the customer.
   * @param customerId The id of the customer.
   * @param userId The id of the user.
   * @param body (optional) The request containing the new user data.
   * @return OK
   */
  updateUsers(
    customerId: number,

    userId: number,

    body?: UpdateCustomerUserRequest | undefined,
    options?: RequestOptions
  ): Observable<GetCustomerUserResponse> {
    let url_ = this.baseUrl + '/customers/{customerId}/users/{userId}';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'put',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUsers(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateUsers(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetCustomerUserResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetCustomerUserResponse>;
          }
        })
      );
  }

  protected processUpdateUsers(response: HttpResponseBase): Observable<GetCustomerUserResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerUserResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetCustomerUserResponse>(null as any);
  }

  /**
     * Activates or deactivates a user of the customer. Deactivation blocks further logins and
    revokes existing sessions; reactivation restores login. Setting the current state again
    is a no-op.
     * @param customerId The id of the customer.
     * @param userId The id of the user.
     * @param body (optional) The request containing the desired status.
     * @return OK
     */
  updateUsersStatus(
    customerId: number,

    userId: number,

    body?: UpdateCustomerUserStatusRequest | undefined,
    options?: RequestOptions
  ): Observable<GetCustomerUserResponse> {
    let url_ = this.baseUrl + '/customers/{customerId}/users/{userId}/status';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'put',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUsersStatus(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateUsersStatus(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetCustomerUserResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetCustomerUserResponse>;
          }
        })
      );
  }

  protected processUpdateUsersStatus(
    response: HttpResponseBase
  ): Observable<GetCustomerUserResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerUserResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetCustomerUserResponse>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class KvkClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
   * Gets a company profile by its KvK number.
   * @param kvkNumber The KvK number.
   * @return OK
   */
  getProfile(kvkNumber: string, options?: RequestOptions): Observable<KvkCompanyDto> {
    let url_ = this.baseUrl + '/kvk/profile/{kvkNumber}';
    if (kvkNumber === undefined || kvkNumber === null)
      throw new Error("The parameter 'kvkNumber' must be defined.");
    url_ = url_.replace('{kvkNumber}', encodeURIComponent('' + kvkNumber));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProfile(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetProfile(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<KvkCompanyDto>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<KvkCompanyDto>;
          }
        })
      );
  }

  protected processGetProfile(response: HttpResponseBase): Observable<KvkCompanyDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as KvkCompanyDto);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<KvkCompanyDto>(null as any);
  }

  /**
   * Searches Dutch companies by name or by KvK number.
   * @param query The search query: a company name, or a KvK number.
   * @return OK
   */
  getSearch(query: string, options?: RequestOptions): Observable<KvkSearchResponse> {
    let url_ = this.baseUrl + '/kvk/search?';
    if (query === undefined || query === null)
      throw new Error("The parameter 'query' must be defined and cannot be null.");
    else url_ += 'query=' + encodeURIComponent('' + query) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSearch(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetSearch(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<KvkSearchResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<KvkSearchResponse>;
          }
        })
      );
  }

  protected processGetSearch(response: HttpResponseBase): Observable<KvkSearchResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as KvkSearchResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<KvkSearchResponse>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class LanguagesClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
   * Gets the language by its id.
   * @param languageId The id of the language to retrieve.
   * @return OK
   */
  getById(languageId: number, options?: RequestOptions): Observable<GetLanguageResponse> {
    let url_ = this.baseUrl + '/languages/{languageId}';
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined.");
    url_ = url_.replace('{languageId}', encodeURIComponent('' + languageId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetLanguageResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetLanguageResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<GetLanguageResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetLanguageResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetLanguageResponse>(null as any);
  }

  /**
   * Retrieves a list of languages.
   * @return OK
   */
  get(options?: RequestOptions): Observable<GetLanguagesResponse> {
    let url_ = this.baseUrl + '/languages';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetLanguagesResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetLanguagesResponse>;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<GetLanguagesResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetLanguagesResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetLanguagesResponse>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class MeClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
   * Returns the current user's customer context.
   * @return OK
   */
  get(options?: RequestOptions): Observable<MeResponse> {
    let url_ = this.baseUrl + '/me';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<MeResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<MeResponse>;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<MeResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as MeResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<MeResponse>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class PartyTypesClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
   * Gets a party type by id.
   * @param partyType The party type id.
   * @param languageId The language id.
   * @return OK
   */
  getDefault(
    partyType: PartyTypeOptions,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetPartyTypeDefaultFieldsResponse> {
    let url_ = this.baseUrl + '/party-types/{partyType}/default?';
    if (partyType === undefined || partyType === null)
      throw new Error("The parameter 'partyType' must be defined.");
    url_ = url_.replace('{partyType}', encodeURIComponent('' + partyType));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDefault(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetDefault(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetPartyTypeDefaultFieldsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetPartyTypeDefaultFieldsResponse>;
          }
        })
      );
  }

  protected processGetDefault(
    response: HttpResponseBase
  ): Observable<GetPartyTypeDefaultFieldsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as GetPartyTypeDefaultFieldsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetPartyTypeDefaultFieldsResponse>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class SigningProviderConfigsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
   * Creates or updates a signing provider configuration for the current customer.
   * @param provider The signing provider type.
   * @param body (optional) The upsert request.
   * @return OK
   */
  update(
    provider: SigningProviderType,

    body?: UpsertSigningProviderConfigRequest | undefined,
    options?: RequestOptions
  ): Observable<SigningProviderConfigResponse> {
    let url_ = this.baseUrl + '/signing-provider-configs/{provider}';
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'put',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<SigningProviderConfigResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<SigningProviderConfigResponse>;
          }
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<SigningProviderConfigResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SigningProviderConfigResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SigningProviderConfigResponse>(null as any);
  }

  /**
   * Gets a signing provider configuration by provider type. Returns the config regardless of enabled status.
   * @param provider The signing provider type.
   * @return OK
   */
  getById(
    provider: SigningProviderType,
    options?: RequestOptions
  ): Observable<SigningProviderConfigResponse> {
    let url_ = this.baseUrl + '/signing-provider-configs/{provider}';
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<SigningProviderConfigResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<SigningProviderConfigResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<SigningProviderConfigResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SigningProviderConfigResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SigningProviderConfigResponse>(null as any);
  }

  /**
   * Gets all signing provider configurations for the current customer, including disabled ones.
   * @return OK
   */
  get(options?: RequestOptions): Observable<SigningProviderConfigResponse[]> {
    let url_ = this.baseUrl + '/signing-provider-configs';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<
                  SigningProviderConfigResponse[]
                >;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<
              SigningProviderConfigResponse[]
            >;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<SigningProviderConfigResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as SigningProviderConfigResponse[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SigningProviderConfigResponse[]>(null as any);
  }

  /**
     * Gets all active (enabled) signing provider configurations for the current customer. Open to
    every office user (not admin-only like the rest of the controller): it names the enabled
    providers without any configuration data, and any user starting a signing flow needs it.
     * @return OK
     */
  getActive(options?: RequestOptions): Observable<ActiveSigningProviderResponse[]> {
    let url_ = this.baseUrl + '/signing-provider-configs/active';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetActive(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetActive(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<
                  ActiveSigningProviderResponse[]
                >;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<
              ActiveSigningProviderResponse[]
            >;
          }
        })
      );
  }

  protected processGetActive(
    response: HttpResponseBase
  ): Observable<ActiveSigningProviderResponse[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as ActiveSigningProviderResponse[]);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ActiveSigningProviderResponse[]>(null as any);
  }

  /**
     * Completes the DocuSign OAuth Authorization Code Grant flow.
    Exchanges the authorization code for tokens and creates the provider configuration.
     * @param body (optional) The connect request containing the authorization code.
     * @return OK
     */
  createDocusignConnect(
    body?: DocuSignConnectRequest | undefined,
    options?: RequestOptions
  ): Observable<SigningProviderConfigResponse> {
    let url_ = this.baseUrl + '/signing-provider-configs/docusign/connect';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateDocusignConnect(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateDocusignConnect(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<SigningProviderConfigResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<SigningProviderConfigResponse>;
          }
        })
      );
  }

  protected processCreateDocusignConnect(
    response: HttpResponseBase
  ): Observable<SigningProviderConfigResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SigningProviderConfigResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SigningProviderConfigResponse>(null as any);
  }

  /**
   * Tests the connection to a signing provider using the current customer's configuration.
   * @param provider The signing provider type.
   * @return OK
   */
  createTestConnection(
    provider: SigningProviderType,
    options?: RequestOptions
  ): Observable<SigningProviderTestConnectionResponse> {
    let url_ = this.baseUrl + '/signing-provider-configs/{provider}/test-connection';
    if (provider === undefined || provider === null)
      throw new Error("The parameter 'provider' must be defined.");
    url_ = url_.replace('{provider}', encodeURIComponent('' + provider));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateTestConnection(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateTestConnection(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<SigningProviderTestConnectionResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<SigningProviderTestConnectionResponse>;
          }
        })
      );
  }

  protected processCreateTestConnection(
    response: HttpResponseBase
  ): Observable<SigningProviderTestConnectionResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as SigningProviderTestConnectionResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SigningProviderTestConnectionResponse>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class SigningRequestsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
   * Creates a new signing request in draft state.
   * @param body (optional) The creation request.
   * @return OK
   */
  create(
    body?: CreateSigningRequestDto | undefined,
    options?: RequestOptions
  ): Observable<GetSigningRequestResponse> {
    let url_ = this.baseUrl + '/signing-requests';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetSigningRequestResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetSigningRequestResponse>;
          }
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<GetSigningRequestResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetSigningRequestResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetSigningRequestResponse>(null as any);
  }

  /**
   * Gets a signing request by its identifier.
   * @param requestId The signing request identifier.
   * @return OK
   */
  getById(requestId: number, options?: RequestOptions): Observable<GetSigningRequestResponse> {
    let url_ = this.baseUrl + '/signing-requests/{requestId}';
    if (requestId === undefined || requestId === null)
      throw new Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetSigningRequestResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetSigningRequestResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<GetSigningRequestResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetSigningRequestResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetSigningRequestResponse>(null as any);
  }

  /**
     * Updates a signing request's documents and parties configuration.
    Only allowed when the request is in Draft or Configured status.
     * @param requestId The signing request identifier.
     * @param body (optional) The update request with document and party configurations.
     * @return OK
     */
  update(
    requestId: number,

    body?: UpdateSigningRequestDto | undefined,
    options?: RequestOptions
  ): Observable<GetSigningRequestResponse> {
    let url_ = this.baseUrl + '/signing-requests/{requestId}';
    if (requestId === undefined || requestId === null)
      throw new Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'put',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetSigningRequestResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetSigningRequestResponse>;
          }
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<GetSigningRequestResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetSigningRequestResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetSigningRequestResponse>(null as any);
  }

  /**
     * Sends the signing request to the external provider.
    Transitions the request from Configured to Sent status.
     * @param requestId The signing request identifier.
     * @param body (optional) The send configuration with language and optional custom email body.
     * @return OK
     */
  createSend(
    requestId: number,

    body?: SendSigningRequestDto | undefined,
    options?: RequestOptions
  ): Observable<GetSigningRequestResponse> {
    let url_ = this.baseUrl + '/signing-requests/{requestId}/send';
    if (requestId === undefined || requestId === null)
      throw new Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateSend(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateSend(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetSigningRequestResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetSigningRequestResponse>;
          }
        })
      );
  }

  protected processCreateSend(response: HttpResponseBase): Observable<GetSigningRequestResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetSigningRequestResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetSigningRequestResponse>(null as any);
  }

  /**
   * Cancels an active signing request, deleting it and reverting the contract status.
   * @param requestId The signing request identifier.
   * @return OK
   */
  createCancel(requestId: number, options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/signing-requests/{requestId}/cancel';
    if (requestId === undefined || requestId === null)
      throw new Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateCancel(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateCancel(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateCancel(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Gets the available artifacts and parties for configuring a signing request on a contract.
   * @param contractId The contract identifier.
   * @return OK
   */
  getContractsSigningOptions(
    contractId: number,
    options?: RequestOptions
  ): Observable<SigningOptionsResponse> {
    let url_ = this.baseUrl + '/signing-requests/contracts/{contractId}/signing-options';
    if (contractId === undefined || contractId === null)
      throw new Error("The parameter 'contractId' must be defined.");
    url_ = url_.replace('{contractId}', encodeURIComponent('' + contractId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetContractsSigningOptions(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetContractsSigningOptions(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<SigningOptionsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<SigningOptionsResponse>;
          }
        })
      );
  }

  protected processGetContractsSigningOptions(
    response: HttpResponseBase
  ): Observable<SigningOptionsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SigningOptionsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SigningOptionsResponse>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class SigningWebhooksClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
     * Receives signing callback events from OK Sign.
    OK Sign sends GET requests with signing status in query parameters.
     * @param requestId Optional signing request ID embedded in the callback URL.
     * @return OK
     */
  getWebhooksOksign(requestId: number, options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/signing/webhooks/oksign/{requestId}';
    if (requestId === undefined || requestId === null)
      throw new Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetWebhooksOksign(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetWebhooksOksign(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processGetWebhooksOksign(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Receives signing callback events from Penneo, correlating by caseFile ID in the payload.
   * @return OK
   */
  createWebhooksPenneo(options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/signing/webhooks/penneo';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateWebhooksPenneo(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateWebhooksPenneo(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateWebhooksPenneo(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Receives signing callback events from Penneo with the signing request ID embedded in the URL.
   * @param requestId The signing request ID embedded in the callback URL.
   * @return OK
   */
  createWebhooksPenneo_POST2(requestId: number, options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/signing/webhooks/penneo/{requestId}';
    if (requestId === undefined || requestId === null)
      throw new Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateWebhooksPenneo_POST2(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateWebhooksPenneo_POST2(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateWebhooksPenneo_POST2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
     * Handles NitroSign webhook callbacks.
    NitroSign sends POST requests with a JSON body containing packageId and packageStatus.
     * @return OK
     */
  createWebhooksNitrosign(requestId: number, options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/signing/webhooks/nitrosign/{requestId}';
    if (requestId === undefined || requestId === null)
      throw new Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateWebhooksNitrosign(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateWebhooksNitrosign(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateWebhooksNitrosign(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
     * Handles DocuSign Connect webhook callbacks (Organization-Level configuration).
    DocuSign sends POST requests with a JSON body (SIM format) without a request ID in the URL.
    The signing request is matched by envelope ID from the payload.
     * @return OK
     */
  createWebhooksDocusign(options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/signing/webhooks/docusign';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateWebhooksDocusign(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateWebhooksDocusign(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateWebhooksDocusign(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
     * Handles DocuSign Connect webhook callbacks.
    DocuSign sends POST requests with a JSON body (SIM format) containing envelope status updates.
     * @param requestId The signing request ID embedded in the callback URL.
     * @return OK
     */
  createWebhooksDocusign_POST2(requestId: number, options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/signing/webhooks/docusign/{requestId}';
    if (requestId === undefined || requestId === null)
      throw new Error("The parameter 'requestId' must be defined.");
    url_ = url_.replace('{requestId}', encodeURIComponent('' + requestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateWebhooksDocusign_POST2(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateWebhooksDocusign_POST2(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateWebhooksDocusign_POST2(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
     * Handles Hix webhook callbacks. Hix registers webhooks per account rather than per task, so the
    URL names the customer, with a token bound to it, and the task is matched from the payload.
     * @param customerId The customer whose Hix account the webhook was registered on.
     * @return OK
     */
  createWebhooksHix(customerId: number, options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/signing/webhooks/hix/{customerId}';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateWebhooksHix(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateWebhooksHix(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateWebhooksHix(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class SupportExtensionClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
     * Describes the request behind a link: which contract, the current deadline, and the deadline
    accepting would set.
     * @param token The token from the link.
     * @return OK
     */
  get(token: string, options?: RequestOptions): Observable<SupportExtensionDto> {
    let url_ = this.baseUrl + '/support-extension?';
    if (token === undefined || token === null)
      throw new Error("The parameter 'token' must be defined and cannot be null.");
    else url_ += 'token=' + encodeURIComponent('' + token) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<SupportExtensionDto>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<SupportExtensionDto>;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<SupportExtensionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SupportExtensionDto);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SupportExtensionDto>(null as any);
  }

  /**
   * Accepts the request: support access to the contract is extended by one access period.
   * @param body (optional) The answer, carrying the token from the link.
   * @return OK
   */
  createAccept(
    body?: AnswerSupportExtensionRequest | undefined,
    options?: RequestOptions
  ): Observable<SupportExtensionDto> {
    let url_ = this.baseUrl + '/support-extension/accept';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateAccept(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateAccept(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<SupportExtensionDto>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<SupportExtensionDto>;
          }
        })
      );
  }

  protected processCreateAccept(response: HttpResponseBase): Observable<SupportExtensionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SupportExtensionDto);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SupportExtensionDto>(null as any);
  }

  /**
   * Declines the request: support access ends at the current deadline.
   * @param body (optional) The answer, carrying the token from the link.
   * @return OK
   */
  createDecline(
    body?: AnswerSupportExtensionRequest | undefined,
    options?: RequestOptions
  ): Observable<SupportExtensionDto> {
    let url_ = this.baseUrl + '/support-extension/decline';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateDecline(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateDecline(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<SupportExtensionDto>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<SupportExtensionDto>;
          }
        })
      );
  }

  protected processCreateDecline(response: HttpResponseBase): Observable<SupportExtensionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SupportExtensionDto);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SupportExtensionDto>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class SupportTicketsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
     * Files a support ticket for a contract the caller can see. The office, contract model,
    country, access deadline (seven days) and status are set by the server; a notification is
    sent to the support inbox once the ticket is stored.
     * @param body (optional) The ticket to file.
     * @return OK
     */
  create(
    body?: CreateSupportTicketRequest | undefined,
    options?: RequestOptions
  ): Observable<SupportTicketDto> {
    let url_ = this.baseUrl + '/support-tickets';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<SupportTicketDto>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<SupportTicketDto>;
          }
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<SupportTicketDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as SupportTicketDto);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SupportTicketDto>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class UserGroupsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://accountant.dev.instaclause.com/api';
  }

  /**
   * Retrieves the user groups of the customer with user and contract model counts.
   * @param customerId The id of the customer.
   * @return OK
   */
  getUserGroups(customerId: number, options?: RequestOptions): Observable<GetUserGroupsResponse> {
    let url_ = this.baseUrl + '/customers/{customerId}/user-groups';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserGroups(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetUserGroups(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetUserGroupsResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetUserGroupsResponse>;
          }
        })
      );
  }

  protected processGetUserGroups(response: HttpResponseBase): Observable<GetUserGroupsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetUserGroupsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetUserGroupsResponse>(null as any);
  }

  /**
   * Creates a new user group for the customer.
   * @param customerId The id of the customer.
   * @param body (optional) The request containing the user group name and optional description.
   * @return OK
   */
  createUserGroups(
    customerId: number,

    body?: CreateUserGroupRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateUserGroupResponse> {
    let url_ = this.baseUrl + '/customers/{customerId}/user-groups';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUserGroups(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateUserGroups(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<CreateUserGroupResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CreateUserGroupResponse>;
          }
        })
      );
  }

  protected processCreateUserGroups(
    response: HttpResponseBase
  ): Observable<CreateUserGroupResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateUserGroupResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateUserGroupResponse>(null as any);
  }

  /**
     * Retrieves the details of a single user group, including its members and assigned
    contract models.
     * @param customerId The id of the customer.
     * @param id The id of the user group.
     * @param languageId The id of the language to localize contract model names in.
     * @return OK
     */
  getUserGroups_GET2(
    customerId: number,

    id: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetUserGroupResponse> {
    let url_ = this.baseUrl + '/customers/{customerId}/user-groups/{id}?';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserGroups_GET2(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetUserGroups_GET2(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetUserGroupResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetUserGroupResponse>;
          }
        })
      );
  }

  protected processGetUserGroups_GET2(
    response: HttpResponseBase
  ): Observable<GetUserGroupResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetUserGroupResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetUserGroupResponse>(null as any);
  }

  /**
   * Updates the name and description of an existing user group.
   * @param customerId The id of the customer.
   * @param id The id of the user group to update.
   * @param body (optional) The request containing the new name and description.
   * @return OK
   */
  updateUserGroups(
    customerId: number,

    id: number,

    body?: UpdateUserGroupRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateUserGroupResponse> {
    let url_ = this.baseUrl + '/customers/{customerId}/user-groups/{id}';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'put',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateUserGroups(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateUserGroups(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<CreateUserGroupResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CreateUserGroupResponse>;
          }
        })
      );
  }

  protected processUpdateUserGroups(
    response: HttpResponseBase
  ): Observable<CreateUserGroupResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateUserGroupResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateUserGroupResponse>(null as any);
  }

  /**
   * Deletes a user group. Only allowed if no users are assigned.
   * @param customerId The id of the customer.
   * @param id The id of the user group to delete.
   * @return OK
   */
  deleteUserGroups(
    customerId: number,

    id: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/customers/{customerId}/user-groups/{id}';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteUserGroups(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteUserGroups(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteUserGroups(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
     * Retrieves every contract model a restriction can point at, bucketed by contract model
    group. The set belongs to the office, so it is the same for every user group and includes
    the models the user groups withhold; which ones a given user group withholds is told by
    that group's detail endpoint.
     * @param languageId The id of the language to localize contract model names in.
     * @return OK
     */
  getUserGroupsContractModels(
    languageId: number,

    customerId: string,
    options?: RequestOptions
  ): Observable<GetUserGroupContractModelsResponse> {
    let url_ = this.baseUrl + '/customers/{customerId}/user-groups/contract-models?';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetUserGroupsContractModels(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetUserGroupsContractModels(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetUserGroupContractModelsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetUserGroupContractModelsResponse>;
          }
        })
      );
  }

  protected processGetUserGroupsContractModels(
    response: HttpResponseBase
  ): Observable<GetUserGroupContractModelsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as GetUserGroupContractModelsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetUserGroupContractModelsResponse>(null as any);
  }

  /**
     * Assigns users to a user group, moving them out of their current group — every user
    belongs to exactly one group, so an assignment is always a move, never an addition.
     * @param customerId The id of the customer.
     * @param id The id of the user group.
     * @param body (optional) The request containing user ids to assign.
     * @return OK
     */
  createUserGroupsUsers(
    customerId: number,

    id: number,

    body?: UserGroupUsersRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/customers/{customerId}/user-groups/{id}/users';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUserGroupsUsers(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateUserGroupsUsers(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateUserGroupsUsers(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
     * Withholds contract models from a user group: its members stop seeing them, even though
    the office still can.
     * @param customerId The id of the customer.
     * @param id The id of the user group.
     * @param body (optional) The request containing contract model ids to withhold.
     * @return OK
     */
  createUserGroupsRestrictedContractModels(
    customerId: number,

    id: number,

    body?: UserGroupContractModelsRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/customers/{customerId}/user-groups/{id}/restricted-contract-models';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateUserGroupsRestrictedContractModels(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateUserGroupsRestrictedContractModels(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateUserGroupsRestrictedContractModels(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Lifts the restriction on contract models, handing them back to the group's members.
   * @param customerId The id of the customer.
   * @param id The id of the user group.
   * @param body (optional) The request containing contract model ids to hand back.
   * @return OK
   */
  deleteUserGroupsRestrictedContractModels(
    customerId: number,

    id: number,

    body?: UserGroupContractModelsRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/customers/{customerId}/user-groups/{id}/restricted-contract-models';
    if (customerId === undefined || customerId === null)
      throw new Error("The parameter 'customerId' must be defined.");
    url_ = url_.replace('{customerId}', encodeURIComponent('' + customerId));
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteUserGroupsRestrictedContractModels(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteUserGroupsRestrictedContractModels(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteUserGroupsRestrictedContractModels(
    response: HttpResponseBase
  ): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

/** Lightweight response representing an active (enabled) signing provider. */
export interface ActiveSigningProviderResponse {
  /** The configuration identifier. */
  id: number;
  /** Defines the supported signing providers. */
  provider: SigningProviderType;
}

/** Represents a request to add a representative to an existing assignment. Exactly one of CustomerContactId or NewContact must be provided. */
export interface AddRepresentativeRequest {
  /** The id of an existing customer contact to add as a representative. */
  customerContactId?: number | undefined;
  /** The details of a contact to create and add as a representative in the same operation. */
  newContact?: CreateContactRequest | undefined;
}

/** Represents the result of adding a representative to an assignment. */
export interface AddRepresentativeResponse {
  /** The id of the representative contact, whether pre-existing or created by the request. */
  customerContactId: number;
  /** The state of the contract wizard after the representative was added. */
  wizardStateDto?: WizardStateDto | undefined;
}

/** Represents a request to answer the role fields required of a contract assignment. */
export interface AnswerAssignmentFieldsRequest {
  /** The field values to record against the assigned contact. Every field must be one the assignment currently requires. */
  fields: ContactFieldRequest[];
}

/** Represents the result of answering the role fields of a contract assignment. */
export interface AnswerAssignmentFieldsResponse {
  /** The state of the contract wizard recomputed after the values were recorded, so callers see any change in what is still outstanding without a further request. */
  wizardStateDto?: WizardStateDto | undefined;
}

/** Request containing the field id and the value to answer a customer contact field. */
export interface AnswerContactFieldRequest {
  /** Gets the field id. */
  fieldId: number;
  /** Gets the value. Whitespace-only values are accepted, since a single space is a deliberate
answer rather than a missing one. */
  value: string;
  /** Gets the legacy field id the value came from, when the contact is being created from a legacy
contract. It replaces Instaclause.Accountant.Contracts.Contacts.AnswerContactFieldRequest.FieldId there, since a legacy field id addresses the legacy
envelope rather than the local catalog. */
  legacyFieldId?: string | undefined;
  /** Gets the origin of the value, so values pre-filled from an external registry stay
distinguishable from values typed by the user. Omitted means Instaclause.Domain.Customers.ContactFieldOriginOptions.Manual.
Only Instaclause.Domain.Customers.ContactFieldOriginOptions.Manual and Instaclause.Domain.Customers.ContactFieldOriginOptions.Kvk are
accepted; the remaining origins belong to the sync integrations and cannot be claimed through this API. */
  origin?: ContactFieldOriginOptions | undefined;
}

/** Request for answering a field within a contract. */
export interface AnswerFieldRequest {
  /** The id of the field to be answered. */
  fieldId: number;
  /** The provided answer value. */
  value: string;
  /** The legacy string field id (question, register.* or clause.*) for legacy contracts. */
  legacyFieldId?: string | undefined;
}

/** Response for answering a field within a contract. */
export interface AnswerFieldResponse {
  /** The state of the contract wizard. */
  wizardStateDto?: WizardStateDto | undefined;
}

/** The office's answer to a request for more support access time, identified by the token from the emailed link. */
export interface AnswerSupportExtensionRequest {
  /** The token from the link. */
  token: string;
}

/** Represents a request to assign a contact to a specific role within a contract. Exactly one of CustomerContactId or NewContact must be provided. */
export interface AssignContactRequest {
  /** The id of the model role to which the contact is being assigned. */
  modelRoleId: number;
  /** The id of an existing customer contact being assigned. */
  customerContactId?: number | undefined;
  /** The details of a contact to create and assign in the same operation. */
  newContact?: CreateContactRequest | undefined;
}

/** Represents the result of assigning a contact to a role within a contract. */
export interface AssignContactResponse {
  /** The id of the assigned customer contact, whether pre-existing or created by the request. */
  customerContactId: number;
  /** The id of the created assignment. Null for legacy contracts, where the assignment is not stored locally. */
  assigneeId?: number | undefined;
  /** The state of the contract wizard after the assignment. */
  wizardStateDto?: WizardStateDto | undefined;
}

/** Represents a group of steps in the wizard (e.g. questions, roles, clauses, documents). */
export interface WizardStepGroupDto {
  /** Whether all steps in this group are completed. */
  completed: boolean;
}

/** Represents a group of steps in the wizard that contains field groups (clauses). */
export interface ClausesStepGroupDto extends WizardStepGroupDto {
  /** The list of field group steps within this group. */
  steps?: WizardFieldsStepDto[];
}

/** Represents an assignment of a contact to a specific model role within a contract. */
export interface ContactAssignmentDto {
  /** Gets or sets the identifier of the assignee. */
  assigneeId: number;
  /** Gets or sets the identifier of the contract model role associated with this contact. */
  modelRoleId: number;
  /** Gets or sets the display name of the model role associated with this contact. */
  modelRoleName: string;
  /** Gets or sets the unique identifier of the customer contact. */
  customerContactId: number;
  /** Gets or sets the name of the customer contact assigned to the role. */
  customerContactName: string;
  /** Represents the options for the type of party that can be involved in contracts. */
  partyType: PartyTypeOptions;
  /** Gets or sets a value indicating whether the contact assignment has missing or incomplete data. */
  hasMissingData: boolean;
  /** Gets or sets the list of fields associated with the contact in this assignment. */
  fields: FieldDto[];
  representatives: RepresentativeDto[];
}

/** Represents the origin of a contact, indicating how the contact was created or imported. */
export enum ContactFieldOriginOptions {
  Unknown = 'Unknown',
  Manual = 'Manual',
  AdminPulse = 'AdminPulse',
  FidManager = 'FidManager',
  AdminConsult = 'AdminConsult',
  Exact = 'Exact',
  Tess = 'Tess',
  Simplicate = 'Simplicate',
  Kvk = 'Kvk',
  HubSpot = 'HubSpot',
}

/** Request containing the contact field and, field id and the value of a customer contact field. */
export interface ContactFieldRequest {
  /** Gets the field id. */
  fieldId: number;
  /** Gets the value. */
  value: string;
  /** Gets the legacy field id. */
  legacyFieldId?: string | undefined;
  /** Gets the origin of the value, so values pre-filled from an external registry stay
distinguishable from values typed by the user. Omitted means Instaclause.Domain.Customers.ContactFieldOriginOptions.Manual.
Only Instaclause.Domain.Customers.ContactFieldOriginOptions.Manual and Instaclause.Domain.Customers.ContactFieldOriginOptions.Kvk are
accepted; the remaining origins belong to the sync integrations and cannot be claimed through this API. */
  origin?: ContactFieldOriginOptions | undefined;
}

/** The contact matched by a registration number lookup. */
export interface ContactRegistrationMatchDto {
  /** The identifier of the matching contact. */
  customerContactId: number;
  /** The name of the matching contact. */
  name: string;
}

/** Describes a relation between the contact being created or updated and another contact of the same customer, together with the data that belongs to that specific relation. */
export interface ContactRelationRequest {
  /** Gets or sets the id of the related contact. */
  contactId: number;
  /** Gets or sets the number of shares the individual/shareholder holds in the company. */
  numberOfShares?: number | undefined;
  /** Gets or sets the number of votes the individual/shareholder holds in the company. */
  numberOfVotes?: number | undefined;
  /** Gets or sets the function/role of the individual/shareholder within the company. */
  function?: string | undefined;
}

/** DTO for Contract Metadata. */
export interface ContractMetadataDto {
  /** List of contract models names. */
  contractModelsNames: string[];
  /** List of customer contacts names. */
  customerContactsNames: string[];
}

/** Data transfer object representing a contract model. */
export interface ContractModelDetailDto {
  /** The id of the contract model. */
  contractModelId: number;
  /** The name of the contract model. */
  name: string;
  /** The introduction of the contract model. */
  introduction: string;
  /** The versions of the contract model. */
  versions: ContractModelSnapshotDto[];
  /** The documents associated with the contract model. */
  documents: DocumentDto[];
  /** The translations of the contract model. */
  translations: ContractModelTranslationDto[];
  /** The id of the contract model (category) in 1.9. */
  legacyCategoryId?: string | undefined;
}

/** Data transfer object representing a contract model. */
export interface ContractModelGroupDto {
  /** The id of the contract model group. */
  contractModelGroupId: number;
  /** The name of the contract model group. */
  name: string;
  /** The list of contract models in the group. */
  contractModels: ContractModelSummaryDto[];
}

/** Data transfer object representing a contract model version. */
export interface ContractModelSnapshotDto {
  snapshotContractModelId: number;
  /** The version of the contract model. */
  version: string;
  /** The time the contract model version was created. */
  createdAt?: Date | undefined;
  /** The description of the contract model version. */
  description?: string | undefined;
}

/** Data transfer object representing a contract model summary. */
export interface ContractModelSummaryDto {
  /** The id of the contract model. */
  contractModelId: number;
  /** The name of the contract model. */
  name: string;
  /** The translations of the contract model. */
  translations: ContractModelTranslationDto[];
  /** The legacy category id when the model originates from an imported legacy category; null for standard 2.0 models. */
  legacyCategoryId?: string | undefined;
}

/** Data transfer object representing a contract model translation. */
export interface ContractModelTranslationDto {
  /** The id of the language of the contract model. */
  languageId: number;
  /** The completion progress of the contract model translation. */
  completion: number;
}

/** Represents a contract model with its associated documents. */
export interface ContractModelWithDocumentsDto {
  /** Gets or sets the ID of the contract model. */
  contractModelId: number;
  /** Gets or sets the ID of the original reference contract model. */
  referenceEntityId?: number | undefined;
  /** Gets or sets the name of the contract model. */
  name: string;
  /** Gets or sets the list of documents associated with the contract model. */
  documents: ContractSummaryDocumentDto[];
}

/** Represents a summary of a document associated with a contract. */
export interface ContractSummaryDocumentDto {
  /** Gets or sets the ID of the document. */
  documentId: number;
  /** Gets or sets the name of the document. */
  name: string;
}

/** Represents a summary of a contract. */
export interface ContractSummaryDto {
  /** Gets or sets the ID of the contract. */
  contractId: number;
  /** Gets or sets the name of the contract. */
  name: string;
  /** Gets or sets the contract model associated with the contract. */
  contractModel: ContractModelWithDocumentsDto;
  /** Gets or sets the status of the contract. */
  status: ContractSummaryStatusDto;
  /** Gets or sets the name of the client contact for the contract. */
  clientContactName: string;
  /** Gets or sets the ID of the client contact for the contract, or null when the contract has none. */
  clientContactId?: number | undefined;
  /** Gets or sets the list of assignees for the contract. */
  assignees: string[];
  /** Gets or sets the timestamps associated with the contract. */
  timeStamps: TimeStampsDto;
  /** Gets or sets a value indicating whether this contract is backed by a legacy (1.9) imported category. */
  isLegacy: boolean;
  /** Gets or sets a value indicating whether the contract is locked after document generation and must be unlocked before its fields or parties can be edited. */
  isLocked: boolean;
  /** Represents the country a customer operates in. Drives country-level availability of default
party fields and their options, per-country field attribute overrides, and the selection of
the customer's prototype integration environment. */
  countryCode: Country;
  /** Gets or sets the support access the logged user reached the contract through, or null when they
opened it as a member of its office. Drives the support banner. */
  supportAccess?: ContractSupportAccessDto | undefined;
}

/** Represents the status of a contract summary. */
export interface ContractSummaryStatusDto {
  /** Gets or sets the status of the contract. */
  status: string;
  /** Gets or sets additional data related to the status. */
  data?: string | undefined;
}

/** The support grant a back office admin reached a contract through. */
export interface ContractSupportAccessDto {
  /** Gets or sets the id of the support ticket that justifies the access. */
  supportTicketId: number;
  /** Gets or sets the moment the access ends. */
  expiresAt: Date;
}

/** Represents the country a customer operates in. Drives country-level availability of default party fields and their options, per-country field attribute overrides, and the selection of the customer's prototype integration environment. */
export enum Country {
  BE = 'BE',
  NL = 'NL',
}

/** Response containing the customer contact field id of the created customer contact field. */
export interface CreateContactFieldResponse {
  /** The id of the created customer contact field. */
  customerContactFieldId: number;
}

/** Request containing the data to create a customer contact. The contact's name is not sent: it is derived from the name fields (first, middle and last name for an individual; the name field for a company). */
export interface CreateContactRequest {
  /** Represents the options for the type of party that can be involved in contracts. */
  partyTypeId: PartyTypeOptions;
  /** Gets or sets the fields. */
  fields?: AnswerContactFieldRequest[] | undefined;
  /** Gets or sets the related contact IDs. Relations listed here are created without relation-specific data;
use Instaclause.Accountant.Contracts.Contacts.CreateContactRequest.RelatedContacts to also provide the number of shares, number of votes and function. */
  relatedContactIds?: number[] | undefined;
  /** Gets or sets the related contacts together with their relation-specific data.
Combined with Instaclause.Accountant.Contracts.Contacts.CreateContactRequest.RelatedContactIds; a contact listed in both takes its data from here. */
  relatedContacts?: ContactRelationRequest[] | undefined;
}

/** Response containing the customer contact id of the created customer contact. */
export interface CreateContactResponse {
  /** The id of the created customer contact. */
  customerContactId: number;
}

/** Request containing the name, the contract model id and the customer id to create a contract. When the referenced contract model originates from an imported legacy (1.9) category, the contract is created through the legacy contract creation flow instead. */
export interface CreateContractRequest {
  /** The id of the language used for the contract. */
  languageId: number;
  /** The name of the contract. */
  name: string;
  /** The id of the contract model snapshot. */
  snapshotContractModelId: number;
  /** The id of the client contact associated with the contract. */
  clientContactId: number;
}

/** Response containing the contract id of the created contract and the initial wizard state. */
export interface CreateContractResponse {
  /** The id of the created contract. */
  contractId: number;
  /** The state of the contract wizard right after creation. */
  wizardStateDto?: WizardStateDto | undefined;
}

/** Request containing the data to create a user for a customer. */
export interface CreateCustomerUserRequest {
  /** The email of the user. */
  email: string;
  /** The password of the user. */
  password: string;
  /** The display name of the user. */
  displayName: string;
  /** Represents the role of a user in the system, such as an administrator or a regular user.
New values must be appended (never reordered): the role is persisted as its integer ordinal.
Auditor and Supervisor are Accountant tiers whose capabilities are not yet implemented, so they
currently behave like Instaclause.Domain.Users.UserRole.User (least privilege). */
  userRole: UserRole;
}

/** Response containing the id of the created user. */
export interface CreateCustomerUserResponse {
  /** The id of the created user. */
  userId: number;
}

/** Request to create a new signing request. */
export interface CreateSigningRequestDto {
  /** The contract identifier. */
  contractId: number;
  /** Defines the supported signing providers. */
  provider: SigningProviderType;
}

/** Request to file a support ticket for a contract the caller can see. The office, contract model, country, access deadline and status are set by the server and cannot be supplied. */
export interface CreateSupportTicketRequest {
  /** Gets or sets the id of the contract the request is about. */
  contractId: number;
  /** The kind of request a customer files with support. Values are persisted as integers, so new
members must be appended and existing ones never renumbered. */
  type: SupportTicketType;
  /** Gets or sets the message for support. Must not be empty. */
  message: string;
  /** Gets or sets the page the customer was on when filing the ticket. */
  url?: string | undefined;
  /** Gets or sets a value indicating whether the customer allows support to open the contract
for the access window. Defaults to true when omitted. */
  consentGranted: boolean;
}

/** Request containing the data to create a user group. */
export interface CreateUserGroupRequest {
  /** Gets or sets the name of the user group. */
  name: string;
  /** Gets or sets the optional description of the user group. */
  description?: string | undefined;
}

/** Response containing the id of the created user group. */
export interface CreateUserGroupResponse {
  /** The id of the created user group. */
  userGroupId: number;
}

/** Represents a customer contact data transfer object. */
export interface CustomerContactDto {
  /** Gets the ID of the customer contact. */
  customerContactId: number;
  /** Gets the name of the customer contact. */
  name: string;
  /** Represents the options for the type of party that can be involved in contracts. */
  partyType: PartyTypeOptions;
  /** Gets the fields associated with the customer contact. */
  fields: CustomerContactFieldDto[];
  /** Gets the distinct origins of the field values associated with the customer contact. */
  origins: ContactFieldOriginOptions[];
  /** Gets the relations associated with the customer contact. */
  relations: CustomerContactRelationDto[];
  /** Gets the timestamps associated with the customer contact. */
  timeStamps: TimeStampsDto;
}

/** Represents a field. */
export interface CustomerContactFieldDto {
  /** Gets the id of the field. */
  fieldId: number;
  /** Gets the label of the field. */
  label: string;
  /** Gets the description of the field. */
  description: string;
  /** Gets the field type. */
  type: string;
  /** Gets the validation regex for the field. */
  validationRegex?: string | undefined;
  /** Gets the value of the field. */
  value?: string | undefined;
}

/** Represents a customer contact list data transfer object. */
export interface CustomerContactListDto {
  /** Gets the ID of the customer contact. */
  customerContactId: number;
  /** Gets the name of the customer contact. */
  name: string;
  /** Represents the options for the type of party that can be involved in contracts. */
  partyType: PartyTypeOptions;
  /** Gets the distinct origins of the field values associated with the customer contact. */
  origins: ContactFieldOriginOptions[];
  /** Gets the timestamps associated with the customer contact. */
  updatedInfo: UpdatedInfoDto;
}

export interface CustomerContactRelationDto {
  /** Gets the ID of the customer contact relation. */
  contactId: number;
  /** Gets the name of the customer contact relation. */
  name?: string | undefined;
  /** Gets the function/role of the related contact (e.g. "Bestuurder", "Zaakvoerder"). */
  function?: string | undefined;
  /** Gets the number of shares the related contact holds in the company. */
  numberOfShares?: number | undefined;
  /** Gets the number of votes the related contact holds in the company. */
  numberOfVotes?: number | undefined;
}

/** Represents a user of a customer (office). Uses init-only properties (not a positional constructor) so EF can translate the generic search/sort filters applied after projection. */
export interface CustomerUserDto {
  /** Gets the id of the user. */
  userId: number;
  /** Gets the display name of the user. */
  displayName: string;
  /** Gets the email of the user. */
  email: string;
  /** Represents the role of a user in the system, such as an administrator or a regular user.
New values must be appended (never reordered): the role is persisted as its integer ordinal.
Auditor and Supervisor are Accountant tiers whose capabilities are not yet implemented, so they
currently behave like Instaclause.Domain.Users.UserRole.User (least privilege). */
  userRole: UserRole;
  /** Gets the date the user was deactivated, or null when the user is active. */
  deactivatedAt?: Date | undefined;
  /** Gets the id of the user group the user belongs to. Every accountant user belongs to
exactly one group, so this is null only for a user whose membership is missing.
Membership is changed through the user groups endpoints, not here. */
  userGroupId?: number | undefined;
}

/** Represents the result of deleting a role assignment from a contract. */
export interface DeleteAssignmentResponse {
  /** The state of the contract wizard recomputed after the assignment was deleted, so callers see what became outstanding without a further request. */
  wizardStateDto?: WizardStateDto | undefined;
}

/** Represents the result of deleting a field answer from a contract. */
export interface DeleteFieldResponse {
  /** The state of the contract wizard recomputed after the answer was deleted, so callers see what became outstanding without a further request. */
  wizardStateDto?: WizardStateDto | undefined;
}

/** Request to complete the DocuSign OAuth Authorization Code Grant flow. The frontend obtains the authorization code via the DocuSign login popup and sends it here for exchange into access/refresh tokens. */
export interface DocuSignConnectRequest {
  /** The authorization code received from the DocuSign OAuth redirect. */
  code: string;
}

/** Data transfer object representing a document. */
export interface DocumentDto {
  /** The id of the document. */
  documentId: number;
  /** The name of the document. */
  name: string;
}

/** Represents how far a contract document has got through generation, so the wizard can list a document that is still being produced instead of only ones that already have a file. */
export enum DocumentGenerationStatus {
  NotGenerated = 'NotGenerated',
  Generating = 'Generating',
  Ready = 'Ready',
  Failed = 'Failed',
}

/** Represents the state of a single document within a contract. */
export interface DocumentStateDto {
  /** The document identifier. */
  documentId: number;
  /** The pre-signed URL to download the document, if ready. */
  url?: string | undefined;
  /** Whether the document has been digitally signed. */
  isSigned: boolean;
  /** Whether the document has been generated and is ready for download. */
  isReady: boolean;
  /** How far the document has got through generation. */
  generationStatus: DocumentGenerationStatus;
  /** Whether the document has been edited by hand and saved in the in-app editor. */
  isEdited: boolean;
  /** The name of the user who last saved a manual edit, if any. */
  editedByName?: string | undefined;
  /** When the last manual edit was saved, if any. */
  editedAt?: Date | undefined;
}

/** Represents a group of steps in the wizard that contains documents. */
export interface DocumentsStepGroupDto extends WizardStepGroupDto {
  /** The list of document steps within this group. */
  steps?: WizardDocumentsStepDto[];
}

/** Request to duplicate an existing contract. */
export interface DuplicateContractRequest {
  /** Whether to copy role assignees (parties) to the new contract. */
  keepAssignees: boolean;
}

/** Response containing the id of the duplicated contract. */
export interface DuplicateContractResponse {
  /** The id of the newly created contract. */
  contractId: number;
}

/** Represents a field. */
export interface FieldDto {
  /** Gets the id of the field. */
  fieldId: number;
  /** Gets the id of the field. */
  referenceEntityId?: number | undefined;
  /** Gets the label of the field. */
  label: string;
  /** Gets the description of the field. */
  description: string;
  /** Gets the field type. */
  type: string;
  /** Gets the validation regex for the field. */
  validationRegex?: string | undefined;
  /** Gets the options for the field. */
  options?: FieldOptionDto[] | undefined;
  /** Gets the value of the field, or `null` when the field is unanswered. For `select` fields it is
always one of `options[].value`, so the selected option is found by comparing against the option
value - never against its label. */
  value?: string | undefined;
  /** Gets the legacy string field id for legacy contracts, used to answer the field in the legacy platform. */
  legacyFieldId?: string | undefined;
}

/** Represents an option for a field. */
export interface FieldOptionDto {
  /** Gets the id of the field option. */
  fieldOptionId: number;
  /** Gets the label of the field option. */
  label: string;
  /** Gets the value of the field option: the answer to send for this option, and what the field value holds
once the option is chosen. The label is display text only and is never a valid answer. */
  value: string;
}

/** The response containing the accountants. */
export interface GetAccountantsResponse {
  /** The accountants. */
  accountants: UserDto[];
}

/** Response of the lookup of a contact by its registration number, carrying the matching contact of the logged-in customer, or null when no contact holds the number. */
export interface GetContactByRegistrationNumberResponse {
  /** The matching contact, or null when no contact corresponds to the number. */
  contact?: ContactRegistrationMatchDto | undefined;
}

/** Response containing the contracts associated with a contact. */
export interface GetContactContractsResponse {
  /** The collection of contracts associated with the contact. */
  contracts: ContractSummaryDto[];
}

/** Response containing the missing fields of a customer contact. */
export interface GetContactMissingFieldsResponse {
  /** The missing fields of the customer contact. */
  fields: FieldDto[];
}

/** Response containing the customer contacts. */
export interface GetContactResponse {
  /** The customer contact. */
  contact: CustomerContactDto;
}

/** Response containing the customer contacts. */
export interface GetContactsResponse {
  /** The customer contacts. */
  contacts: CustomerContactListDto[];
}

/** Response containing the values of the fields of a contract. */
export interface GetContractFieldsValuesResponse {
  /** The list of field values. */
  fields: FieldDto[];
}

/** Response containing the contract metadata. */
export interface GetContractMetadataResponse {
  /** The contract metadata. */
  metadata: ContractMetadataDto;
}

/** Response containing the contract model groups. */
export interface GetContractModelGroupsResponse {
  /** The list of contract model groups. */
  groups: ContractModelGroupDto[];
}

/** Response containing the contract model. */
export interface GetContractModelResponse {
  /** The contract model. */
  contractModel: ContractModelDetailDto;
}

/** Response containing the contract state. */
export interface GetContractResponse {
  /** Basic infos about the contract. */
  contractSummary: ContractSummaryDto;
  /** The full wizard navigation state for the contract. */
  wizardState: WizardStateDto;
}

/** Response containing the contracts. */
export interface GetContractsResponse {
  /** The list of contracts. */
  contracts: ContractSummaryDto[];
}

/** Response containing a single user of a customer. */
export interface GetCustomerUserResponse {
  /** The user. */
  user: CustomerUserDto;
}

/** Response containing the list of users of a customer. */
export interface GetCustomerUsersResponse {
  /** The list of users. */
  users: CustomerUserDto[];
}

export interface GetLanguageResponse {
  language: LanguageDto;
}

export interface GetLanguagesResponse {
  languages: LanguageDto[];
}

/** Represents a response to get party type default fields. */
export interface GetPartyTypeDefaultFieldsResponse {
  /** The party type default fields. */
  fields: PartyTypeFieldDto[];
}

/** Response representing the full state of a signing request. */
export interface GetSigningRequestResponse {
  /** The signing request identifier. */
  requestId: number;
  /** The contract identifier. */
  contractId: number;
  /** Represents the status of a signing request. */
  status: SigningRequestStatus;
  /** Defines the supported signing providers. */
  provider: SigningProviderType;
  /** The list of documents in the request. */
  documents: SigningDocumentDto[];
  /** The date and time when the request was created. */
  createdAt: Date;
}

/** Response containing every contract model the customer's user group restrictions can point at, bucketed by contract model group. The set is the office's, so it is the same for every user group; which of them a given user group withholds is told by that group's detail response. */
export interface GetUserGroupContractModelsResponse {
  /** The contract model groups holding the models a restriction can point at. */
  groups: ContractModelGroupDto[];
}

/** Response containing the details of a single user group. */
export interface GetUserGroupResponse {
  /** The user group details. */
  userGroup: UserGroupDetailDto;
}

/** Response containing the list of user groups. */
export interface GetUserGroupsResponse {
  /** The list of user groups. */
  userGroups: UserGroupListDto[];
}

/** A Dutch company profile resolved from the KvK (Kamer van Koophandel) registry, normalized to the canonical party-type slots used by customer contacts. */
export interface KvkCompanyDto {
  /** Gets the company statutory (or trade) name. */
  name: string;
  /** Gets the street name of the company's main address. */
  street?: string | undefined;
  /** Gets the house number, including any letter and addition, of the main address. */
  houseNumber?: string | undefined;
  /** Gets the postal code of the main address. */
  postalCode?: string | undefined;
  /** Gets the municipality (city) of the main address. */
  municipality?: string | undefined;
  /** Gets the legal-entity type as one of the option values of the "Type of legal entity"
select field (e.g. "BV", "NV", "VOF", "Stichting"), or null when the KvK rechtsvorm has
no matching option. Safe to persist on the field as-is. */
  legalEntityType?: string | undefined;
  /** Gets the legal-entity type exactly as KvK reports it (the "rechtsvorm"), e.g.
"Besloten Vennootschap" or "Eenmanszaak". For display only; it is not an option value. */
  legalEntityTypeRaw?: string | undefined;
  /** Gets the KvK number of the company. */
  kvkNumber: string;
}

/** The result of a KvK company search. */
export interface KvkSearchResponse {
  /** The matching companies. */
  results: KvkSearchResultDto[];
}

/** A single company match returned by the KvK search API. */
export interface KvkSearchResultDto {
  /** Gets the KvK number of the company. */
  kvkNumber: string;
  /** Gets the company name. */
  name: string;
  /** Gets the city of the company, when the search result exposes one. */
  city?: string | undefined;
  /** Gets the KvK record type, e.g. "hoofdvestiging" or "rechtspersoon". */
  type?: string | undefined;
}

export interface LanguageDto {
  languageId: number;
  name: string;
  code: string;
}

/** Represents the signed URL payload returned by the legacy document download endpoint. */
export interface LegacyDocumentDownloadUrlResponse {
  /** The signed download URL. */
  url: string;
  /** The file name to download. */
  fileName: string;
  /** The selected file format. */
  format: string;
}

/** Represents the current user's customer context. */
export interface MeResponse {
  /** Represents the country a customer operates in. Drives country-level availability of default
party fields and their options, per-country field attribute overrides, and the selection of
the customer's prototype integration environment. */
  countryCode: Country;
  /** The name of the current user's customer. */
  customerName: string;
}

/** Represents a party type field with its identifier, field details, and whether it is required. */
export interface PartyTypeFieldDto {
  partyTypeFieldId: number;
  /** Represents a field. */
  field: FieldDto;
  isRequired: boolean;
}

/** Represents the options for the type of party that can be involved in contracts. */
export enum PartyTypeOptions {
  Company = 'Company',
  Individual = 'Individual',
}

/** Represents a group of steps in the wizard that contains questions. */
export interface QuestionsStepGroupDto extends WizardStepGroupDto {
  /** The list of question steps within this group. */
  steps?: WizardFieldsStepDto[];
}

/** Represents the result of removing a representative from an assignment. */
export interface RemoveRepresentativeResponse {
  /** The state of the contract wizard recomputed after the representative was removed, so callers see what became outstanding without a further request. */
  wizardStateDto?: WizardStateDto | undefined;
}

export interface RepresentativeDto {
  /** Gets or sets the unique identifier of the customer contact. */
  customerContactId: number;
  /** Gets or sets the name of the customer contact assigned to the role. */
  customerContactName: string;
  /** Gets or sets a value indicating whether the contact assignment has missing or incomplete data. */
  hasMissingData: boolean;
  /** Represents the options for the type of party that can be involved in contracts. */
  partyType: PartyTypeOptions;
  /** Gets or sets the list of fields associated with the contact in this assignment. */
  fields: FieldDto[];
}

/** Represents the state of a specific role within a contract model, including its assignments and validation status. */
export interface RoleStateDto {
  /** Gets or sets the identifier of the role. */
  roleId: number;
  /** Gets or sets the identifier of the model role. */
  modelRoleId: number;
  /** Gets or sets a value indicating whether this role has missing required assignments. */
  hasMissingAssignments: boolean;
  /** Gets or sets the display label of the role. */
  label: string;
  /** Gets or sets the minimum number of required assignees for this role. */
  min: number;
  /** Gets or sets the maximum number of allowed assignees for this role. */
  max: number;
  /** Gets or sets the count of the party assignments. */
  count?: number | undefined;
  /** Gets or sets the collection of allowed party type identifiers for this role. */
  allowedTypesId: PartyTypeOptions[];
  /** Gets or sets the allowed party types for representatives of this role. */
  allowedRepresentativeTypeIds: PartyTypeOptions[];
  /** Gets or sets the list of contact assignments associated with this role. */
  assignees?: ContactAssignmentDto[] | undefined;
  /** Gets or sets the legacy string party id for legacy contracts, used to set the party total in the legacy platform. */
  legacyPartyId?: string | undefined;
  /** Gets or sets the list of role fields associated with this role. */
  roleFields: RoleFields;
}

/** Represents a group of steps in the wizard that contains roles. */
export interface RolesStepGroupDto extends WizardStepGroupDto {
  /** The list of role steps within this group. */
  steps?: WizardRoleStepDto[];
}

/** Request to send a signing request to the external provider. */
export interface SendSigningRequestDto {
  /** The language code for signing notifications (e.g., "en", "nl", "fr"). */
  language: string;
  /** Optional custom email body. When null, a default localized body is used. */
  emailBody?: string | undefined;
}

/** Represents the result of setting the number of assignees a contract role expects. */
export interface SetAssigneeCountResponse {
  /** The state of the contract wizard recomputed after the count was set, so callers see what became outstanding without a further request. */
  wizardStateDto?: WizardStateDto | undefined;
}

/** An available contract artifact that can be included in a signing request. */
export interface SigningArtifactOption {
  /** The contract artifact identifier, used in the update request. */
  contractArtifactId: number;
  /** The document identifier. */
  documentId: number;
  /** The display name of the document. */
  documentName: string;
  /** The ISO language code of the artifact (e.g., "nl", "fr", "en"). */
  languageCode: string;
}

/** A document within a signing request. */
export interface SigningDocumentDto {
  /** The signing document identifier. */
  id: number;
  /** The contract artifact identifier. */
  contractArtifactId: number;
  /** The document definition identifier. */
  documentId: number;
  /** Whether this document has been signed. */
  isSigned: boolean;
  /** The parties assigned to sign this document. */
  parties: SigningPartyDto[];
}

/** Response containing the available artifacts and parties for configuring a signing request. */
export interface SigningOptionsResponse {
  /** The list of available contract artifacts (generated PDFs). */
  artifacts: SigningArtifactOption[];
  /** The list of available contract role assignees (potential signers). */
  parties: SigningPartyOption[];
}

/** A signing party within a document. */
export interface SigningPartyDto {
  /** The signing party identifier. */
  id: number;
  /** The display name. */
  name: string;
  /** The email address. */
  email: string;
  /** The role in the contract. */
  role: string;
  /** The notification order. */
  notificationOrder: number;
  /** The optional contract role assignee identifier. */
  contractRoleAssigneeId?: number | undefined;
  /** Represents the signing status of an individual party on a document. */
  status: SigningPartyStatus;
  /** The date and time when signing was completed, if applicable. */
  signedAt?: Date | undefined;
  /** The mobile number entered for the party, if any. */
  mobile?: string | undefined;
}

/** An available contract role assignee that can be added as a signing party. */
export interface SigningPartyOption {
  /** The contract role assignee identifier, or null for a legacy (1.9) contract, whose assignments live
on the legacy platform and have no `contract_role_assignees` row here. */
  contractRoleAssigneeId?: number | undefined;
  /** The contact display name. */
  name: string;
  /** The contract role name (e.g., "Bestuurder", "CEO"). */
  roleName: string;
  /** The email address, or null if not available in the contact data. */
  email?: string | undefined;
  /** The phone number, or null if not available in the contact data. Suggested as the signer's mobile
for providers that need one (Hix). */
  phone?: string | undefined;
}

/** Represents the signing status of an individual party on a document. */
export enum SigningPartyStatus {
  Pending = 'Pending',
  Sent = 'Sent',
  Signed = 'Signed',
  Failed = 'Failed',
  Declined = 'Declined',
}

/** Response representing a signing provider configuration. */
export interface SigningProviderConfigResponse {
  /** The configuration identifier. */
  id: number;
  /** The customer identifier. */
  customerId: number;
  /** Defines the supported signing providers. */
  provider: SigningProviderType;
  /** Whether the provider configuration is enabled. */
  enabled: boolean;
  /** The provider-specific configuration as a JSON object. */
  configData: any;
}

/** Response returned when a signing provider connection test succeeds. */
export interface SigningProviderTestConnectionResponse {
  /** The connection status. Always `connected` on success; failures are returned as problem details. */
  status: string;
}

/** Defines the supported signing providers. */
export enum SigningProviderType {
  OkSign = 'OkSign',
  Penneo = 'Penneo',
  NitroSign = 'NitroSign',
  DocuSign = 'DocuSign',
  Hix = 'Hix',
}

/** Represents the status of a signing request. */
export enum SigningRequestStatus {
  Draft = 'Draft',
  Configured = 'Configured',
  Sent = 'Sent',
  PartiallySigned = 'PartiallySigned',
  Completed = 'Completed',
  Failed = 'Failed',
  Cancelled = 'Cancelled',
}

/** What the office is asked to agree to when support requests more time, as shown on the page the emailed link opens. */
export interface SupportExtensionDto {
  /** The state of a request for more support access time. Values are persisted as integers, so new
members must be appended and existing ones never renumbered. */
  status: SupportExtensionRequestStatus;
  /** Whether the request can still be accepted or declined through the link. */
  canAnswer: boolean;
  /** The name of the office that filed the ticket. */
  officeName: string;
  /** The name of the contract support is working on. */
  contractName: string;
  /** The moment support access ends: the current deadline, or the extended one once accepted. */
  expiresAt: Date;
  /** The deadline accepting now would set; null once the request can no longer be answered. */
  extendedExpiresAt?: Date | undefined;
  /** The moment the link stops working. */
  linkExpiresAt: Date;
}

/** The state of a request for more support access time. Values are persisted as integers, so new members must be appended and existing ones never renumbered. */
export enum SupportExtensionRequestStatus {
  Pending = 'Pending',
  Accepted = 'Accepted',
  Declined = 'Declined',
  Cancelled = 'Cancelled',
}

/** A support ticket as returned to the office user that filed it. */
export interface SupportTicketDto {
  /** Gets the id of the support ticket. */
  id: number;
  /** Gets the id of the office the contract belongs to. */
  customerId: number;
  /** Gets the id of the contract the ticket is about. */
  contractId: number;
  /** Gets the id of the contract model the contract was instantiated from. */
  contractModelId: number;
  /** The kind of request a customer files with support. Values are persisted as integers, so new
members must be appended and existing ones never renumbered. */
  type: SupportTicketType;
  /** Gets the message the customer wrote. */
  message: string;
  /** Gets the page the customer was on when filing the ticket. */
  url?: string | undefined;
  /** Represents the country a customer operates in. Drives country-level availability of default
party fields and their options, per-country field attribute overrides, and the selection of
the customer's prototype integration environment. */
  country: Country;
  /** The working state of a support ticket as seen by the Admin app. Values are persisted as
integers, so new members must be appended and existing ones never renumbered. */
  status: SupportTicketStatus;
  /** Gets a value indicating whether the customer allowed support to open the contract. */
  consentGranted: boolean;
  /** Gets the moment until which support may open the contract. */
  expiresAt: Date;
  /** Gets the moment the ticket was finished, or null while it is still open. */
  completedAt?: Date | undefined;
  /** Gets the moment the ticket was filed. */
  createdAt: Date;
  /** Gets the id of the user that filed the ticket. */
  createdByUserId: number;
}

/** The working state of a support ticket as seen by the Admin app. Values are persisted as integers, so new members must be appended and existing ones never renumbered. */
export enum SupportTicketStatus {
  Open = 'Open',
  InProgress = 'InProgress',
  Finished = 'Finished',
}

/** The kind of request a customer files with support. Values are persisted as integers, so new members must be appended and existing ones never renumbered. */
export enum SupportTicketType {
  Question = 'Question',
  Issue = 'Issue',
}

export interface TimeStampsDto {
  createdAt: Date;
  createdByUser: UserDto;
  updatedAt?: Date | undefined;
  updatedByUser?: UserDto | undefined;
  deletedAt?: Date | undefined;
  deletedByUser?: UserDto | undefined;
}

/** Response for unlocking a contract. */
export interface UnlockContractResponse {
  /** The state of the contract wizard after the unlock. */
  wizardStateDto: WizardStateDto;
}

/** Request containing the data to update a customer contact. The contact's name is not sent: it is recomputed from the name fields after the field changes are applied. */
export interface UpdateContactRequest {
  /** Gets or sets the unique identifier for the contact. */
  contactId: number;
  /** Gets or sets the fields for upsert. */
  fieldsToUpsert?: ContactFieldRequest[] | undefined;
  /** Gets or sets the fields for removal. */
  fieldsToRemove?: number[] | undefined;
  /** Gets or sets the related contact ids. Existing relations listed here keep their relation-specific data;
use Instaclause.Accountant.Contracts.Contacts.UpdateContactRequest.RelatedContacts to set the number of shares, number of votes and function.
When both this and Instaclause.Accountant.Contracts.Contacts.UpdateContactRequest.RelatedContacts are null, all relations are removed. */
  relatedContactIds?: number[] | undefined;
  /** Gets or sets the related contacts together with their relation-specific data.
Combined with Instaclause.Accountant.Contracts.Contacts.UpdateContactRequest.RelatedContactIds; a contact listed in both takes its data from here.
Relations not listed in either collection are removed. */
  relatedContacts?: ContactRelationRequest[] | undefined;
}

/** Request to update a contract. */
export interface UpdateContractRequest {
  /** The new name of the contract. */
  name?: string | undefined;
  /** The wizard group type to navigate to, if updating wizard position. */
  wizardGroupType?: WizardGroupType | undefined;
  /** The index within the wizard group, if updating wizard position. */
  wizardGroupIndex?: number | undefined;
}

/** Request containing the data to update a user of a customer. The email is immutable. */
export interface UpdateCustomerUserRequest {
  /** The display name of the user. */
  displayName: string;
  /** Represents the role of a user in the system, such as an administrator or a regular user.
New values must be appended (never reordered): the role is persisted as its integer ordinal.
Auditor and Supervisor are Accountant tiers whose capabilities are not yet implemented, so they
currently behave like Instaclause.Domain.Users.UserRole.User (least privilege). */
  userRole: UserRole;
}

/** Request to activate or deactivate a user of a customer. */
export interface UpdateCustomerUserStatusRequest {
  /** Whether the user should be active. */
  isActive: boolean;
}

/** Configuration for a single document in a signing request update. */
export interface UpdateSigningDocumentConfig {
  /** The contract artifact identifier (the generated PDF). */
  contractArtifactId: number;
  /** The list of parties that must sign this document. */
  parties: UpdateSigningPartyConfig[];
}

/** Configuration for a single signing party in a request update. */
export interface UpdateSigningPartyConfig {
  /** The display name of the signing party. */
  name: string;
  /** The email address where the signing invitation is sent. */
  email: string;
  /** The role of the party (e.g., "Bestuurder", "CEO"). */
  role: string;
  /** The order in which this party receives the signing notification. */
  notificationOrder: number;
  /** The optional contract role assignee identifier. */
  contractRoleAssigneeId?: number | undefined;
  /** The optional mobile number. Only Hix reads it, for a signer who has no Hix account; when it is
empty the contact's phone is used instead. */
  mobile?: string | undefined;
}

/** Request to configure or update a signing request with documents and parties. */
export interface UpdateSigningRequestDto {
  /** The list of documents to be signed, each with their assigned parties. */
  documents: UpdateSigningDocumentConfig[];
}

/** Request containing the new snapshot id to update a contract. */
export interface UpdateSnapshotRequest {
  /** The id of the new snapshot. */
  newSnapshotContractModelId: number;
}

/** Request containing the data to update a user group. */
export interface UpdateUserGroupRequest {
  /** Gets or sets the new name of the user group. */
  name: string;
  /** Gets or sets the new description of the user group; null clears it. */
  description?: string | undefined;
}

export interface UpdatedInfoDto {
  updatedAt?: Date | undefined;
  updatedByUser?: UserDto | undefined;
}

/** Request to create or update a signing provider configuration. */
export interface UpsertSigningProviderConfigRequest {
  /** Whether the provider configuration is enabled. */
  enabled: boolean;
  /** The provider-specific configuration as a JSON object. Optional: may be omitted only to disable an already configured provider, keeping the stored configuration unchanged. */
  configData?: any | undefined;
}

export interface UserDto {
  userId: number;
  customerId?: number | undefined;
  displayName: string;
  email: string;
  /** Represents the type of user in the system, such as an expert or an accountant. */
  userType: UserType;
  /** Represents the role of a user in the system, such as an administrator or a regular user.
New values must be appended (never reordered): the role is persisted as its integer ordinal.
Auditor and Supervisor are Accountant tiers whose capabilities are not yet implemented, so they
currently behave like Instaclause.Domain.Users.UserRole.User (least privilege). */
  userRole: UserRole;
  deactivatedAt?: Date | undefined;
}

/** Represents a contract model withheld from a user group. */
export interface UserGroupContractModelDto {
  /** Gets the id of the contract model. */
  contractModelId: number;
  /** Gets the name of the contract model in the requested language. */
  name: string;
}

/** Request containing the ids of the contract models to withhold from a user group, or to hand back to it. */
export interface UserGroupContractModelsRequest {
  /** Gets or sets the list of contract model ids. */
  contractModelIds: number[];
}

/** Represents the details of a user group, including its members and the contract models withheld from it. */
export interface UserGroupDetailDto {
  /** Gets the id of the user group. */
  id: number;
  /** Gets the name of the user group. */
  name: string;
  /** Gets the optional description of the user group. */
  description?: string | undefined;
  /** Gets a value indicating whether this is the customer's default user group, which
group-less users are enrolled into automatically and which cannot be deleted. */
  isDefault: boolean;
  /** Gets the users assigned to the group. */
  users: UserGroupUserDto[];
  /** Gets the contract models withheld from the group: its members cannot see them. An empty
list means the group's members see everything their office sees. */
  restrictedContractModels: UserGroupContractModelDto[];
}

/** Represents a user group in a list view. */
export interface UserGroupListDto {
  /** Gets the id of the user group. */
  id: number;
  /** Gets the name of the user group. */
  name: string;
  /** Gets the optional description of the user group. */
  description?: string | undefined;
  /** Gets a value indicating whether this is the customer's default user group, which
group-less users are enrolled into automatically and which cannot be deleted. */
  isDefault: boolean;
  /** Gets the number of users in the group. */
  userCount: number;
  /** Gets the number of contract models withheld from the group. Zero means the group's
members see everything their office sees. */
  restrictedContractModelCount: number;
}

/** Represents a user assigned to a user group. */
export interface UserGroupUserDto {
  /** Gets the id of the user. */
  userId: number;
  /** Gets the display name of the user. */
  displayName: string;
  /** Gets the email of the user. */
  email: string;
}

/** Request containing user ids to add to or remove from a user group. */
export interface UserGroupUsersRequest {
  /** Gets or sets the list of user ids. */
  userIds: number[];
}

/** Represents the role of a user in the system, such as an administrator or a regular user. New values must be appended (never reordered): the role is persisted as its integer ordinal. Auditor and Supervisor are Accountant tiers whose capabilities are not yet implemented, so they currently behave like Instaclause.Domain.Users.UserRole.User (least privilege). */
export enum UserRole {
  Admin = 'Admin',
  User = 'User',
  Auditor = 'Auditor',
  Supervisor = 'Supervisor',
}

/** Represents the type of user in the system, such as an expert or an accountant. */
export enum UserType {
  Expert = 'Expert',
  Accountant = 'Accountant',
  BackOffice = 'BackOffice',
}

/** Represents a single step within a wizard group. */
export interface WizardStepDto {
  /** The stable entity identifier for this step (questionId, modelRoleId, fieldGroupId, or the group type name for documents). */
  id: string;
  /** The display name of this step. */
  name: string;
  /** The index of this step within the group. */
  displayIndex: string;
  /** Whether this step is completed. */
  completed: boolean;
}

/** Represents a single step within a wizard group that contains documents. */
export interface WizardDocumentsStepDto extends WizardStepDto {
  /** The list of documents associated with this step. */
  documents?: DocumentStateDto[] | undefined;
  /** The latest signing request associated with this contract, if any. */
  latestSigningRequest?: GetSigningRequestResponse | undefined;
}

/** Represents a single step within a wizard group that contains fields (e.g. questions or clauses). */
export interface WizardFieldsStepDto extends WizardStepDto {
  fields?: FieldDto[] | undefined;
}

/** Represents the type of wizard group in the contract wizard. */
export enum WizardGroupType {
  Questions = 'Questions',
  Roles = 'Roles',
  Clauses = 'Clauses',
  Documents = 'Documents',
}

/** Represents the current wizard navigation progress for a contract. */
export interface WizardProgressDto {
  /** Represents the type of wizard group in the contract wizard. */
  currentGroupType: WizardGroupType;
  /** The current step index within the wizard group. */
  currentStepIndex: number;
}

/** Represents a single step within a wizard group that contains a role (e.g. roles). */
export interface WizardRoleStepDto extends WizardStepDto {
  /** The role associated with this step. */
  role?: RoleStateDto | undefined;
}

/** Represents the full wizard navigation state for a contract. */
export interface WizardStateDto {
  /** The questions step group. */
  questions: QuestionsStepGroupDto;
  /** The roles step group. */
  roles: RolesStepGroupDto;
  /** The clauses step group. */
  clauses: ClausesStepGroupDto;
  /** The documents step. */
  documents?: DocumentsStepGroupDto | undefined;
  /** The resolved current wizard progress, if any. */
  currentProgress?: WizardProgressDto | undefined;
  /** Whether the contract is locked after document generation; its fields and parties cannot be edited until it is unlocked. */
  isLocked: boolean;
}

export interface RoleFields {
  Company?: FieldDto[];
  Individual?: FieldDto[];
  IndividualRepresentative?: FieldDto[];
  CompanyRepresentative?: FieldDto[];
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) {
    return throwError(() => result);
  }

  return throwError(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
